export const docterlist = [
  // {
  //   name: "Dr. D Vijaya Meenakshi",
  //   dis: (
  //     <h6 className="pt-2 font-medium">MBBS, MD - Obstetrics & Gynaecology</h6>
  //   ),

  //   img: "../photo/doc1.jpg",
  //   rate: "",
  //   exper: "20",
  //   link: "/bestobstetricsandgynecologytreatmentsinwhitefield-by-dr-d-vijaya-meenakshi",
  //   depat: "Obstetrics and Gynecology",
  //   con: "Dr. D Vijaya Meenakshi is a Gynaecologist and Obstetrician specializes in High-Risk Pregnancy, Fertility, and Pre-Conceptional Case. Her treatment includes DUB, IUCD insertion, Mirena insertion, laparoscopic tubectomy, diagnostic hysteron laparoscopy, and laparoscopy hysteroscopies. Dr. Meenakshi treats the patient afflicted with breast cancer, hormonal imbalances, and menopause symptoms. She also deals with preventative care, prenatal care, detection of sexually transmitted diseases, Pap test screening, and family planning. Dr. Meenakshi is considered to be one of the famous Obstetricians when it comes to the treatment aspect as she has profound knowledge and proficiency in Normal, C-Section, and High-Risk Pregnancy, and has performed numerous cases successfully.",
  // },
  {
    name: "Dr. Ajay S S",
    dis: <h6 className="pt-2 font-medium">MS - Orthopaedics, MBBS</h6>,
    img: "../photo/doc15.jpg",
    rate: "",
    exper: "6",
    link: "/bestorthopedictreatmentsinwhitefield-by-dr-ajay-s-s",
    depat: "Orthopedic",
    timings: "MON TO FRI - 7:30 PM ON APPT",
    con: "Dr. Ajay S S is a Orthopedic surgeon in Whitefield, Bangalore and has an experience of 6 years in this field. Dr. Ajay S S practices at ELV Health Care in Whitefield, Bangalore. He completed MS - Orthopaedics from Jagadguru Jayadeva Murugarajendra Medical College (JJMMC) in 2020 and MBBS from Rajiv Gandhi University of Health Sciences in 2015.",
  },
  // {
  //   name: "Dr. SACHIN PATIL ",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       M. S. GENERAL SURGERY M.B.B.S. (2009 – 2015)
  //     </h6>
  //   ),
  //   img: "../photo/doc3.jpg",
  //   rate: "",
  //   exper: "5",
  //   depat: "General Surgery",
  //   con: "Dr. Sachin Patil is a highly qualified General Surgeon based in Bangalore, holding an M.B.B.S. degree earned in 2009 and subsequently achieving an M.S. in General Surgery in 2015. With over 5 years of dedicated practice, Dr. Patil has established himself as a trusted healthcare professional. His commitment to the field is reflected in his expertise and compassionate approach to General Surgery. Located in the bustling city of Bangalore, Dr. Sachin Patil serves the community with a focus on providing comprehensive and personalized healthcare, ensuring the well-being of his patients.",
  // },
  // {
  //   name: "Dr. Sainath T V",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       MBBS, DCH, DNB PED, Fellowship in Neonatology, NNF
  //     </h6>
  //   ),
  //   img: "../photo/doc4.jpg",
  //   rate: "",
  //   exper: "7",
  //   depat: "Neonatologist & Pediatrician",
  //   con: "Dr. Sainath T V, a distinguished Neonatologist and Pediatrician based in Bangalore, is a highly qualified medical professional with an impressive academic background. Holding an MBBS degree, DCH (Diploma in Child Health), and DNB PED (Diplomate of National Board in Pediatrics), Dr. Sainath has further honed his skills through a Fellowship in Neonatology, accredited by the NNF (National Neonatology Forum). With over 7 years of extensive experience, he is a dedicated healthcare provider committed to the well-being of newborns and children. Dr. Sainath's expertise and commitment to neonatal care make him an invaluable asset to the medical community in Bangalore.",
  // },
  // {
  //   name: "Dr. N.S Santhosh",
  //   dis: <h6 className="pt-2 font-medium">MBBS DNB-Neurology</h6>,
  //   img: "../photo/doc5.jpg",
  //   rate: "",
  //   exper: "21",
  //   link: "/bestneurologytreatmentsinwhitefield-by-dr-ns-santhosh",
  //   depat: "Neurologist",
  //   con: "Dr. N.S. Santhosh, a highly regarded Neurologist based in Bangalore, boasts an illustrious medical career spanning over 21 years. Armed with an MBBS degree and specialized training in DNB-Neurology, he has become a seasoned expert in the intricacies of neurological care. Dr. Santhosh's unwavering dedication to his field is reflected not only in his extensive experience but also in his consistently high rating of 4.6/5. His wealth of knowledge and commitment to providing top-notch neurological care positions him as a trusted and compassionate healthcare professional, making a significant impact on the well-being of his patients in Bangalore.",
  // },

  // {
  //   name: "Dr. Pruthviraj MO",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       MBBS, DNB - OBG PGDip-Ultrasonography
  //     </h6>
  //   ),
  //   img: "../photo/doc6.jpg",
  //   rate: "",
  //   exper: "10",
  //   depat: "Obstetrics and Gynecology",
  //   con: "Dr. Pruthviraj MO, an accomplished Obstetrician and Gynecologist based in Bangalore, brings over a decade of expertise to the field of women's healthcare. With an MBBS degree, DNB in Obstetrics and Gynecology, and additional specialization in Ultrasonography through PGDip, Dr. Pruthviraj is a dedicated professional committed to the well-being of his patients. His comprehensive approach to obstetric and gynecological care, coupled with a wealth of knowledge accumulated over 10+ years, establishes him as a trusted healthcare provider. Dr. Pruthviraj's commitment to excellence is reflected in his impressive 4.6/5 rating, showcasing his unwavering dedication to providing quality and compassionate care to women in Bangalore.",
  // },
  {
    name: "Dr. Lipika Debbarma",
    dis: <h6 className="pt-2 font-medium">MBBS, DFM(RCGP,UK), PGDCD</h6>,
    img: "../photo/dr-lipika-debbarma.jpg",
    rate: "4.6",
    exper: "16",
    link: "/bestdermatologytreatmentsinwhitefield-by-dr-lipika-debbarma",
    depat: "Cosmetology & Aesthetic Dermatology",
    timings: "MON TO SAT - ON APPOINTMENT",
    con: `
    <h2>Dr. Lipika D – Leading Expert in Cosmetology & Aesthetic Dermatology</h2>
    <p>Dr. Lipika D is a distinguished Cosmetologist with over 16 years of experience in aesthetic dermatology, skin rejuvenation, and non-surgical cosmetic treatments. With a deep understanding of skin health, hair restoration, and anti-aging solutions, she has successfully helped numerous individuals enhance their appearance and regain confidence. Her expertise lies in providing personalized, evidence-based skincare solutions tailored to different skin types and concerns.</p>

    <h3>Academic Background & Professional Journey</h3>
    <p>Dr. Lipika pursued her MBBS from the prestigious Regional Institute of Medical Sciences, Imphal, in 2009. Her passion for cosmetic dermatology led her to obtain a Post Graduate Diploma in Cosmetic Dermatology (PGDCD) from the Indian Institute of Aesthetic Medicine, Pune, in 2022. Her advanced training has equipped her with in-depth knowledge of modern aesthetic techniques, laser treatments, and minimally invasive cosmetic procedures.</p>

    <h3>Expertise in Advanced Aesthetic Treatments</h3>
    <p>Dr. Lipika is known for her comprehensive and customized approach to skincare and aesthetics. Her expertise includes:</p>
    <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
      <li><strong>Anti-Aging & Skin Rejuvenation</strong> – Specialized in Botox, dermal fillers, and PRP therapy for wrinkle reduction, skin tightening, and facial contouring.</li>
      <li><strong>Acne & Pigmentation Solutions</strong> – Treating acne scars, melasma, hyperpigmentation, and uneven skin tone through chemical peels, microneedling, and laser therapies.</li>
      <li><strong>Non-Surgical Skin Tightening</strong> – Using HIFU (High-Intensity Focused Ultrasound), RF (Radiofrequency), and thread lifts to restore firmness and elasticity.</li>
      <li><strong>Laser Aesthetic Treatments</strong> – Expertise in laser hair removal, laser skin resurfacing, and pigmentation correction for a flawless complexion.</li>
      <li><strong>Hair Restoration & Scalp Therapy</strong> – Providing PRP hair regrowth therapy, mesotherapy, and scalp treatments to combat hair thinning and baldness.</li>
      <li><strong>Advanced Skincare & Glow Boosting Treatments</strong> – Offering hydrafacials, customized medical facials, and medi-spa therapies for a radiant and youthful glow.</li>
      <li><strong>Body Contouring & Fat Reduction</strong> – Non-invasive fat reduction, cellulite treatment, and body sculpting for a well-defined physique.</li>
    </ul>

    <h3>Aesthetic Excellence & Patient-Centric Approach</h3>
    <p>Dr. Lipika believes in a holistic and scientific approach to beauty and wellness. She stays updated with the latest advancements in cosmetic dermatology and adopts FDA-approved, non-invasive, and minimally invasive procedures for safe and long-lasting results. Her patient-centric philosophy ensures that each treatment plan is customized, ethical, and aligned with individual beauty goals.</p>

    <h3>Redefining Beauty with Safe & Effective Treatments</h3>
    <p>With her extensive experience in aesthetic dermatology and regenerative treatments, Dr. Lipika has earned a reputation for delivering natural, long-lasting results while prioritizing patient safety and comfort. She is committed to providing cutting-edge solutions for skin and hair concerns, helping individuals feel confident and rejuvenated.</p>
    `,
  },
  // {
  //   name: "Dr. Razia Sultana",
  //   dis: <h6 className="pt-2 font-medium">MBBS, DLO (ENT)</h6>,
  //   img: "../photo/doc8.jpg",
  //   rate: "",
  //   exper: "5",
  //   link: "/bestenttreatmentsinwhitefield-by-dr-razia-sultana",
  //   depat: "ENT Speialist",
  //   con: "Dr. Razia Sultana, an accomplished ENT Specialist in Bangalore, brings a wealth of expertise to the field of Otolaryngology. Armed with an MBBS degree and specialized training in ENT with a DLO qualification, she possesses a comprehensive understanding of ear, nose, and throat conditions. With over 5 years of dedicated practice, Dr. Razia is committed to providing exceptional care to her patients. Her proficiency is reflected not only in her qualifications but also in her impressive 4.6/5 rating, showcasing her commitment to delivering high-quality and compassionate ENT services to the community in Bangalore.",
  // },
  // {
  //   name: "Dr. Vijyanta Suman",
  //   dis: <h6 className="pt-2 font-medium">BDS, MDS Prostho dentist</h6>,
  //   img: "../photo/doc9.jpg",
  //   rate: "",
  //   exper: "5",
  //   depat: "Prostho dentist",
  //   con: "Dr. Vijyanta Suman, a distinguished Prosthodontist with a BDS and MDS, is a leading practitioner at Elv Health Care. With a wealth of expertise in the field of dentistry, Dr. Suman is dedicated to providing comprehensive and personalized care to her patients. Specializing in Prosthodontics, she excels in the restoration and replacement of teeth, ensuring optimal oral health and aesthetic outcomes. Known for her meticulous approach and commitment to patient well-being, Dr. Suman is a valued member of the Elv Health Care team, where her skills and compassion converge to create smiles that not only look great but also enhance overall oral function and comfort.",
  // },
  {
    name: "Dr. Anirban Bhowmik",
    dis: <h6 className="pt-2 font-medium">MBBS (PGDCC), (PGDD)</h6>,
    img: "../photo/doc10.jpg",
    rate: "",
    exper: "5",
    link: "/bestcardiologytreatmentsinwhitefield-by-dr-anirban-bhowmik",
    depat: "Cardiologist",
    timings: "8:00 AM & 5:00 PM ON APPT",
    con: "Dr. Anirban Bhowmik, a dedicated Cardiologist in Bangalore, brings a wealth of expertise to the field of cardiovascular health. Armed with an MBBS degree, along with specialized qualifications in PGDCC and PGDD, he possesses a comprehensive understanding of cardiac care. With over 5 years of dedicated practice, Dr. Bhowmik is committed to providing exceptional cardiovascular services to his patients. His proficiency and commitment to the well-being of his patients are evident in his impressive 4.6/5 rating. As a trusted healthcare professional, Dr. Anirban Bhowmik plays a vital role in promoting heart health and ensuring the cardiovascular wellness of the community in Bangalore.",
  },
  // {
  //   name: "Dr. Lokesh Gowda T G",
  //   dis: (
  //     <h6 className="pt-2 font-medium">MBBS, MS, MCh (Urology) Urologist</h6>
  //   ),
  //   img: "../photo/doc11.jpg",
  //   rate: "",
  //   exper: "5",
  //   depat: "Urology",
  //   con: "Dr. Lokesh Gowda T G, a highly skilled Urologist in Bangalore, is dedicated to providing expert care in the field of urology. With a robust educational background, including an MBBS, MS, and MCh in Urology, he possesses a comprehensive understanding of urological conditions. Dr. Lokesh Gowda's commitment to excellence is evident in his 5+ years of dedicated practice, during which he has honed his skills and expertise. His proficiency in urology is reflected in his impressive 4.6/5 rating, underscoring his commitment to delivering high-quality and compassionate urological services to the community in Bangalore. Dr. Lokesh Gowda T G stands as a trusted healthcare professional, addressing the urological needs of his patients with precision and care.",
  // },
  // {
  //   name: "Ms. Jeeveetha Ragupathy",
  //   dis: <h6 className="pt-2 font-medium">Dietitian & Nutritionist</h6>,
  //   img: "../photo/doc12.jpg",
  //   rate: "",
  //   exper: "5",
  //   depat: "Dietitian & Nutritionist",
  //   con: "Ms. Jeeveetha Ragupathy, a seasoned Dietitian and Nutritionist in Bangalore, brings over 5 years of expertise to the realm of nutrition and dietary guidance. As a dedicated healthcare professional, she holds the well-being of her clients in high regard, providing personalized and comprehensive nutritional advice. Ms. Ragupathy's educational background equips her with the knowledge and skills necessary to address diverse dietary needs. Her commitment to promoting healthy lifestyles is underscored by her impressive 4.6/5 rating, reflecting the trust and satisfaction of those she has guided on their journey towards better nutrition. In Bangalore, Ms. Jeeveetha Ragupathy stands as a reliable source of nutritional support, ensuring that individuals receive expert guidance tailored to their specific health goals.",
  // },
  {
    name: "Mr. Naveen Kodandaram",
    dis: <h6 className="pt-2 font-medium">Dietitian & Nutritionist</h6>,
    img: "../photo/doc13.jpg",
    rate: "",
    exper: "5",
    link: "/bestdietitianandnutritionisttreatmentsinwhitefield-by-mr-naveen-kodandaram",
    depat: "Dietitian & Nutritionist",
    timings: "ON APPT",
    con: "Mr. Naveen Kodandaram, a dedicated Dietitian and Nutritionist based in Bangalore, brings over 5 years of expertise to the realm of nutrition and wellness. With a commitment to promoting healthy living, he provides personalized dietary guidance to cater to individual health goals. Mr. Kodandaram's approach is rooted in a holistic understanding of nutrition, ensuring that his clients receive comprehensive and tailored advice for their well-being. His extensive experience is a testament to his dedication to the field, and his impressive 4.6/5 rating reflects the satisfaction of those he has assisted on their nutritional journeys. In Bangalore, Mr. Naveen Kodandaram stands as a trusted source of guidance for individuals seeking expert advice to achieve and maintain a balanced and healthy lifestyle.",
  },
  {
    name: "Dr. Binila",
    dis: <h6 className="pt-2 font-medium">BPT, MIAP Physiotherapist</h6>,
    img: "../photo/doc14.jpg",
    rate: "",
    exper: "20",
    link: "/bestphysiotherapyintreatmentsinwhitefield-by-dr-binila",
    depat: "Physiotherapist",
    timings: "MON TO SAT - 8:00 AM TO 6:00 PM",
    con: "Meet Dr. Binila, a highly skilled physiotherapist at Elv Health Care, equipped with a Bachelor's degree in Physiotherapy (BPT) and recognized as a member of the Indian Association of Physiotherapists (MIAP). With a passion for promoting physical well-being, Dr. Binila specializes in providing expert rehabilitation services to patients. Her comprehensive approach and dedication to enhancing mobility and function set her apart, making her an invaluable asset to the healthcare team at Elv Health Care. Driven by a commitment to excellence, she works tirelessly to empower patients on their journey to recovery, utilizing her expertise to address a variety of musculoskeletal and neurological conditions. Dr. Binila's presence brings a vital dimension to Elv Health Care, ensuring that patients receive top-notch physiotherapy care tailored to their unique needs.",
  },
  // {
  //   name: "Dr Ajay S S",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       MBBS, MS (Orthopaedics) FJR, FSCRM Orthopaedic Surgeon
  //     </h6>
  //   ),
  //   img: "../photo/doc15.jpg",
  //   rate: "",
  //   exper: "5",
  //   depat: "Orthopaedic Surgeon",
  //   con: "Dr. Ajay S S, an accomplished Orthopaedic Surgeon, holds both an MBBS and an MS in Orthopaedics, showcasing a robust educational background. With additional qualifications including FJR (Fellowship in Joint Replacement) and FSCRM (Fellowship in Stem Cell and Regenerative Medicine), he brings a comprehensive approach to musculoskeletal care. Dr. Ajay's expertise lies in orthopaedic surgery, with a focus on joint replacement and cutting-edge regenerative medicine. While specific experience and rating details are not mentioned, his commitment to advancing orthopaedic care makes him a trusted professional in the field. Dr. Ajay S S plays a pivotal role in addressing orthopaedic concerns, providing tailored solutions to enhance the mobility and well-being of his patients.",
  // },
  // {
  //   name: "Dr Pavithra",
  //   dis: <h6 className="pt-2 font-medium">MBBS</h6>,
  //   img: "../photo/doc16.jpg",
  //   rate: "",
  //   exper: "5",
  //   depat: "--",
  //   con: "Dr. Pavithra, an esteemed medical professional at MBBS Hospital and Elv Health Care, is a dedicated and compassionate physician with a commitment to providing high-quality healthcare. With a solid background in medicine, she earned her MBBS degree and has since accumulated valuable experience in diagnosing and treating a diverse range of medical conditions. Driven by a passion for patient well-being, she approaches each case with thoroughness and empathy, ensuring personalized care for every individual. Her expertise and warm demeanor make her a trusted figure in the healthcare community, embodying a holistic approach to medicine that prioritizes both physical and emotional well-being. Dr. Pavithra's presence at MBBS Hospital and Elv Health Care significantly contributes to the delivery of exceptional healthcare services.",
  // },
  // {
  //   name: "Dr - vishnuvardhan BR",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       MBBS, MD, general medicine DM Nephrology Renal specialist
  //     </h6>
  //   ),
  //   img: "../photo/doc2.jpg",
  //   rate: "",
  //   exper: "5",
  //   depat: "Nephrologist",
  //   con: "Dr. Pavithra, an esteemed medical professional at MBBS Hospital and Elv Health Care, is a dedicated and compassionate physician with a commitment to providing high-quality healthcare. With a solid background in medicine, she earned her MBBS degree and has since accumulated valuable experience in diagnosing and treating a diverse range of medical conditions. Driven by a passion for patient well-being, she approaches each case with thoroughness and empathy, ensuring personalized care for every individual. Her expertise and warm demeanor make her a trusted figure in the healthcare community, embodying a holistic approach to medicine that prioritizes both physical and emotional well-being. Dr. Pavithra's presence at MBBS Hospital and Elv Health Care significantly contributes to the delivery of exceptional healthcare services.",
  // },
  // {
  //   name: "Dr. Chandrika Chandran",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       MBBS from Calicut Medical College in 1975 and DGO from Kasturba
  //       Medical College, Manipal in 1990
  //     </h6>
  //   ),
  //   img: "../photo/02-04-24.jpg",
  //   rate: "",
  //   exper: "50",
  //   depat: "Gynecologist and Obstetrician",
  //   con: "Dr. Chandrika Chandran is a highly experienced Gynecologist and Obstetrician with an impressive track record spanning over 50 years in the field. She obtained her MBBS degree from Calicut Medical College in 1975, followed by a DGO from Kasturba Medical College, Manipal in 1990. Her specialized areas of expertise include high-risk pregnancy management, infertility treatment, managing cases with a history of bad obstetrics, performing sterilization procedures, cesarean surgeries, and hysterectomy surgeries. Dr. Chandran's extensive experience, coupled with her dedication to providing compassionate care, makes her a trusted and respected figure in the realm of women's health and maternity care.",
  // },
  {
    name: "Dr. Shalini Kumari",
    dis: (
      <h6 className="pt-2 font-medium">
        MBBS, MS( OBG ), FELLOWSHIP IN REPRODUCTIVE MEDICINE( RGUHS),MRCOG
      </h6>
    ),
    img: "../photo/dr-shalini-kumari.png",
    rate: "",
    exper: "11",
    link: "/bestgynecologytreatmentsinwhitefield-by-dr-shalini-kumari",
    depat: "Gynecologist and Obstetrician",
    timings: "MON - SAT - 10:30 AM TO 12:30 PM",
    con: "Dr. Shalini Kumari, a Senior Consultant in Reproductive Medicine with 11 years of experience, specializes in fertility treatments and gynecological procedures. She completed her Fellowship in Reproductive Medicine at Rajiv Gandhi University of Health Sciences, Bangalore, and holds an MS in OBG & GYN. A lifetime member of FOGSI and ISAR, Dr. Shalini expertly manages female sexual problems, PCOD, and offers IUI, IVF, ICSI, hysteroscopy, and laparoscopy services. Additionally, she provides comprehensive prenatal, antenatal check-ups, and addresses menstrual issues. Her extensive expertise and dedication make her a highly regarded specialist in her field.",
  },
  // {
  //   name: "Dr. Kirti S",
  //   dis: <h6 className="pt-2 font-medium">MBBS, MS Otorhinolaryngology</h6>,
  //   img: "/photo/dr-kirti.png",
  //   rate: "",
  //   exper: "11",
  //   link: "/bestentsurgeoninwhitefield-by-dr-kirti-s",
  //   depat: "ENT Surgeon",
  //   con: "Dedicated and skilled ENT surgeon with a strong understanding of the speciality committed to delivering compassionate, patient-centred care. Recognised for precision in surgical technique, empathy in patient interactions and a meticulous approach to treatment. Passionate about improving patient outcomes through expertise, dedication and continuous learning.",
  // },
  //   {
  //     name: "Dr. Vineesh Sukumaran",
  //     dis: (
  //       <h6 className="pt-2 font-medium">
  //         MBBS,Fellowship(Internal Medicine) PGDiploma in Psychology of Mental
  //         Health,Fellowship in Diabetology
  //       </h6>
  //     ),
  //     img: "/doctor-images/Dr-Vineesh-Sukumaran.jpg",
  //     rate: "",
  //     exper: "14",
  //     link: "/bestgeneralphysicianinwhitefield-by-dr-vineesh-sukumaran",
  //     depat: "General Physician/ Internal Medicine",
  //     timings: "MON TO SAT - 10 AM TO 8:30 PM & 24/7",
  //     con: `
  //     <h2>Dr. Vineesh Sukumaran – Experienced General Physician / Internal Medicine Doctor in Bengaluru, India</h2>

  // <p>Dr. Vineesh Sukumaran is a highly regarded General Physician / Internal Medicine Doctor with 14+ years of experience. He practices at <strong>12th Main Rd, above SBI Bank, Sector 6, HSR Layout, Bengaluru, Karnataka 560102, India</strong>. Dr. Vineesh Sukumaran has completed his <strong>MD - Physician</strong> and <strong>Fellowship in Diabetology</strong>. He offers a wide range of services to address various conditions such as <strong>Coughing</strong>, <strong>Thrombocytopenia</strong>, <strong>Toxoplasmosis</strong>, <strong>Upper Respiratory Tract Infections</strong>, <strong>Urinary Tract Infection (UTI)</strong>, <strong>Urine Infection</strong>, and related illnesses. If you're seeking a <strong>Thrombocytopenia</strong> or <strong>Urinary Tract Infection (UTI)</strong> doctor near you, Dr. Vineesh Sukumaran is the right choice.</p>

  // <h3 style="margin-top:30px"><strong>Awards and Recognitions</strong></h3>
  // <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //   <li>Honorary Doctorate in Nature Science and Medicine</li>
  //   <li>Certification in Preventive Cardiology</li>
  //   <li>Fellowship in Diabetology</li>
  //   <li>Diabetes Master Class – Association of Physicians of India (API)</li>
  //   <li>Advanced Class in Diabetes – Association of Physicians of India (API)</li>
  //   <li>Emergency Medicine and Critical Care – Narayana Health</li>
  //   <li>PG Series in General Medicine – Association of Physicians of India (API)</li>
  //   <li>PG Series in Diabetes – Research Society for the Study of Diabetes in India (RSSDI)</li>
  //   <li>Acute Coronary Syndrome – Association of Physicians of India (API)</li>
  //   <li>Medical Emergency – Vikram Hospital, Bangalore</li>
  //   <li>Clinical Nutrition – Indian Society of Gastroenterology (ISG)</li>
  //   <li>Sexual Health – Association of Physicians of India (API)</li>
  //   <li>Prevention of Type 2 Diabetes – International Diabetes Federation Europe</li>
  // </ul>

  // <h3><strong>Memberships</strong></h3>
  // <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //   <li>Indian Medical Association (IMA)</li>
  //   <li>International Diabetes Federation (IDF)</li>
  //   <li>Karnataka Medical Council</li>
  // </ul>

  //     `,
  //   },
  {
    name: "Dr. Shaik Salman Basha",
    dis: <h6 className="pt-2 font-medium">BDS, MDS, (Prosthodontics)</h6>,
    img: "/doctor-images/Dr. Shaik Salman Basha.jpg",
    rate: "",
    exper: "10",
    timings: "MON TO SAT - 10:00 AM TO 8:00 PM",
    link: "/bestdentistryinwhitefield-by-dr-shaik-salman-basha",
    depat: "Dentistry",
    con: `
    <h2>Dr. Shaik Salman Basha – Expert Prosthodontist in Bangalore | Specialist in Dental Implants & Restorative Dentistry</h2>

    <p>Dr. Shaik Salman Basha is a highly skilled Prosthodontist with extensive experience in dental restorations, implants, and aesthetic dentistry. With a strong academic foundation and hands-on clinical expertise, he is committed to providing high-quality dental care to patients, ensuring functional and aesthetic excellence in every treatment.</p>

    <h3>Expertise in Prosthodontics & Restorative Dentistry</h3>
    <p>Dr. Basha specializes in:</p>
    <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
      <li><strong>Dental Implants & Full Mouth Rehabilitation</strong> – Advanced implantology techniques for long-term solutions.</li>
      <li><strong>Crown & Bridge Prosthetics</strong> – Precision restorations for damaged or missing teeth.</li>
      <li><strong>Removable & Fixed Dentures</strong> – Custom prosthetics for enhanced comfort and functionality.</li>
      <li><strong>Smile Designing & Cosmetic Dentistry</strong> – Personalized aesthetic enhancements for a confident smile.</li>
      <li><strong>Maxillofacial Prosthetics</strong> – Specialized prostheses for facial and oral reconstruction.</li>
    </ul>

    <h3>Professional Experience & Education</h3>
    <p>Dr. Basha completed his Bachelor of Dental Surgery (BDS) from Government Osmania Dental College and Hospital, Hyderabad, affiliated with Dr. N.T.R. University of Health Sciences, Vijayawada. Following his passion for prosthodontics, he pursued a Master of Dental Surgery (MDS) in Prosthodontics and Implantology from Narayana Dental College and Hospital, Nellore.</p>

    <p>His professional journey includes:</p>
    <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
      <li>Rotary Internship at Government Osmania Dental College & Hospital, gaining hands-on experience in various dental specialties.</li>
      <li>Clinical Experience in Prosthodontics – Over one year and four months of expertise in advanced prosthodontic treatments.</li>
      <li>Currently working as a full-time Prosthodontist at Liss Dental & Health, Bangalore, providing specialized care in restorative and implant dentistry.</li>
    </ul>

    <h3>Commitment to Patient Care & Innovation</h3>
    <p>With a keen eye for detail and a patient-centric approach, Dr. Basha is dedicated to restoring smiles with precision and care. His expertise in prosthetic rehabilitation, implant-supported dentures, and minimally invasive procedures ensures high success rates and patient satisfaction.</p>

    <p>For consultations and priority appointments, visit Dr. Shaik Salman Basha at Liss Dental & Health, Bangalore.</p>
  `,
  },
  // {
  //   name: "Dr. Anamika Chanda Bhowmik",
  //   dis: <h6 className="pt-2 font-medium">MBBS, MS - ENT</h6>,
  //   img: "/doctor-images/Dr. Anamika Ch Bhowmik.jpeg",
  //   rate: "",
  //   exper: "12",
  //   timings: "MON TO SAT - 5 PM TO 7 PM",
  //   link: "/bestentspecialistinwhitefield-by-dr-anamika-chanda-bhowmik",
  //   depat: "ENT Specialist",
  //   con: `
  //    <p>
  //   Dr. Anamika Ch Bhowmik is an experienced ENT (Otorhinolaryngologist) specialist based in Kadugodi, Bangalore, with over 12 years of experience in the field. She currently practices at Apollo Clinic in Kadugodi. She completed her MBBS from Tripura Medical College in 2012 and pursued her MS in ENT from Agartala Government Medical College in 2022.
  // </p>

  // <h3><strong>Services Offered</strong></h3>
  // <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //   <li>Voice Problem Treatment</li>
  //   <li>Canalplasty</li>
  //   <li>Turbinate Reduction Surgery</li>
  //   <li>Migraine Treatment</li>
  //   <li>Rhinoplasty</li>
  //   <li>Balloon Sinus Ostial Dilation (Balloon Sinuplasty)</li>
  //   <li>Cheek and Tongue Cancer Surgery</li>
  //   <li>Jaw Cancer Surgery</li>
  //   <li>Oral Cancer Surgery</li>
  //   <li>Tympanomastoidectomy</li>
  // </ul>

  // <h3><strong>Specializations</strong></h3>
  // <ul>
  //   <li>ENT / Otorhinolaryngologist</li>
  // </ul>

  // <h3><strong>Education</strong></h3>
  // <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //   <li>MBBS - Tripura Medical College, 2012</li>
  //   <li>MS - ENT - Agartala Government Medical College, 2022</li>
  // </ul>
  //   `,
  // },
  {
    name: "Dr. Anirudh S Rao",
    dis: (
      <h6 className="pt-2 font-medium">
        Orthopedic Surgeon | Arthroscopy, Sports Injury & Joint Replacement
        Specialist
      </h6>
    ),
    img: "/doctor-images/Dr. Anirudh S Rao.jpg",
    rate: "4.8/5",
    exper: "6",
    consultation: "Orthopaedic Consultation",
    timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
    link: "/orthopedic-surgeon-in-bangalore-dr-anirudh-s-rao",
    depat: "Orthopaedics",
    con: `

    <!-- About -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">About Dr. Anirudh S Rao</h2>

      <p class="text-sm text-gray-700">
        Dr. Anirudh S Rao is a skilled Orthopedic Surgeon in Bangalore with expertise in the diagnosis,
        treatment, and surgical management of bone, joint, ligament, and sports-related injuries.
        With 6 years of experience in orthopaedics, he provides comprehensive care for patients
        suffering from musculoskeletal disorders, trauma, arthritis, joint pain, and sports injuries.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        He completed his MBBS from AJ Institute of Medical Sciences, Mangalore in 2020 and pursued
        MS - Orthopaedics from Mandya Institute of Medical Sciences, Mandya in 2025.
        Dr. Anirudh S Rao currently practices at ELV Health Care, Whitefield, Bangalore,
        where he focuses on patient-centered treatment using advanced orthopaedic techniques
        and evidence-based care.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        His clinical interests include arthroscopy procedures, ligament reconstruction surgeries,
        joint replacement surgeries, sports injury management, spine-related treatments,
        and rehabilitation care aimed at restoring mobility and improving quality of life.
      </p>
    </section>

    <!-- Areas of Expertise -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Areas of Expertise</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Shoulder Arthroscopy</li>
        <li>PCL Reconstruction Surgery</li>
        <li>Hip Arthroscopy</li>
        <li>Diagnostic Arthroscopy</li>
        <li>Meniscus Repair Surgery</li>
        <li>Shoulder Replacement Surgery</li>
        <li>Ankle Arthroscopy</li>
        <li>Carpal Tunnel Release</li>
        <li>ACL Surgery</li>
        <li>Joint Pain Treatment</li>
        <li>Soft Tissue Injury Management</li>
        <li>Back Pain Treatment</li>
        <li>Neck Pain Treatment</li>
        <li>Joint Care & Orthopedic Care</li>
        <li>Comprehensive Orthopaedic Treatments</li>
      </ul>
    </section>

    <!-- Services Provided -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Services Provided</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Orthopaedic consultation and diagnosis</li>
        <li>ACL and PCL reconstruction surgeries</li>
        <li>Shoulder arthroscopy and rotator cuff repair</li>
        <li>Meniscus tear treatment and repair surgeries</li>
        <li>Hip and ankle arthroscopy procedures</li>
        <li>Knee replacement surgery</li>
        <li>Hip replacement surgery</li>
        <li>Shoulder replacement surgery</li>
        <li>Spine surgery and spine-related treatments</li>
        <li>Shoulder dislocation treatment</li>
        <li>Carpal tunnel release procedures</li>
        <li>Back pain and neck pain management</li>
        <li>Sports injury and soft tissue injury management</li>
        <li>Joint pain management and rehabilitation</li>
        <li>Advanced orthopedic surgical care</li>
      </ul>
    </section>

    <!-- Why Choose -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Why Choose Dr. Anirudh S Rao?</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Experienced Orthopedic Surgeon in Bangalore</li>
        <li>Expertise in arthroscopy and ligament reconstruction surgeries</li>
        <li>Advanced care for sports injuries and joint disorders</li>
        <li>Patient-focused treatment with personalized care plans</li>
        <li>Modern and evidence-based orthopaedic treatment approaches</li>
        <li>Comprehensive care from diagnosis to rehabilitation</li>
        <li>Practicing at a trusted healthcare center in Whitefield</li>
      </ul>
    </section>

    <!-- Education -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Education & Qualifications</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>MBBS - AJ Institute of Medical Sciences, Mangalore (2020)</li>
        <li>MS - Orthopaedics - Mandya Institute of Medical Sciences, Mandya (2025)</li>
      </ul>
    </section>

    <!-- Conditions Treated -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Conditions Treated</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>ACL and PCL ligament tears</li>
        <li>Meniscus injuries and cartilage damage</li>
        <li>Shoulder dislocation and rotator cuff injuries</li>
        <li>Joint pain and arthritis</li>
        <li>Sports-related injuries</li>
        <li>Back pain and neck pain</li>
        <li>Soft tissue injuries</li>
        <li>Fractures and trauma conditions</li>
        <li>Hand and wrist nerve compression syndromes</li>
      </ul>
    </section>

    <!-- Clinic Details -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Clinic Details</h2>

      <ul class="text-sm text-gray-700 space-y-1">
        <li><strong>Clinic Name:</strong> ELV Health Care</li>
        <li><strong>Location:</strong> Whitefield, Bangalore</li>
        <li><strong>Consultation Days:</strong> Monday to Saturday</li>
        <li><strong>Timings:</strong> As per clinic schedule</li>
      </ul>
    </section>

    <!-- Appointment CTA -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Book an Appointment</h2>

      <a
        href="https://wa.me/919535264855"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
      >
        📞 WhatsApp / Call: 095352 64855
      </a>
    </section>

    <!-- FAQs -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

      <div class="text-sm text-gray-700 space-y-3">

        <div>
          <p class="font-medium">What conditions does Dr. Anirudh S Rao treat?</p>
          <p>
            Dr. Anirudh S Rao treats sports injuries, ligament tears, joint pain, arthritis,
            fractures, shoulder dislocations, meniscus injuries, back pain, neck pain,
            and other orthopaedic conditions.
          </p>
        </div>

        <div>
          <p class="font-medium">Where does Dr. Anirudh S Rao practice?</p>
          <p>
            He practices at ELV Health Care, Whitefield, Bangalore.
          </p>
        </div>

        <div>
          <p class="font-medium">Does he perform arthroscopy surgeries?</p>
          <p>
            Yes, he performs shoulder arthroscopy, hip arthroscopy,
            ankle arthroscopy, and diagnostic arthroscopy procedures.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Anirudh S Rao perform ACL and PCL surgeries?</p>
          <p>
            Yes, he provides advanced ligament reconstruction surgeries including ACL and PCL reconstruction procedures.
          </p>
        </div>

        <div>
          <p class="font-medium">Does he provide joint replacement surgeries?</p>
          <p>
            Yes, he offers orthopedic surgical care including knee replacement,
            hip replacement, and shoulder replacement surgeries.
          </p>
        </div>

      </div>
    </section>
`,
  },
  {
    name: "Dr. Sachin Patil",
    dis: <h6 className="pt-2 font-medium">M.S. GENERAL SURGERY M.B.B.S</h6>,
    img: "/doctor-images/Dr Sachin Patil.jpg",
    rate: "",
    exper: "5",
    timings: "MON TO SAT - 5:30 PM ON APPT",
    link: "/bestgeneralsurgeoninwhitefield-by-dr-sachin-patil",
    depat: "General Surgeon",
    con: `
      <div>
  <h2><strong>Dr. Sachin Patil – Expert General Surgeon | Specialized in Advanced Surgical Care</strong></h2>

  <p>
    Dr. Sachin Patil is a highly skilled General Surgeon with extensive experience in managing complex surgical cases, including major and minor surgeries, trauma care, and critical emergency procedures. Currently serving as an Assistant Professor in General Surgery at Vydehi Institute of Medical Sciences and Research Centre, he is dedicated to delivering exceptional patient care and advancing surgical knowledge through research and innovation.
  </p>

  <h3><strong>Expertise and Specializations</strong></h3>
  <p>
    With over five years of surgical experience, Dr. Sachin Patil has developed proficiency in various surgical procedures, including:
  </p>
  <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
    <li><strong>Elective Surgeries</strong> – Abdomen, Breast, Thyroid, Parotid Surgeries</li>
    <li><strong>Emergency Surgeries</strong> – Trauma, Thoracic Emergencies, Abdominal Surgeries</li>
    <li><strong>Surgical ICU Management</strong> – Handling critical post-operative care</li>
    <li><strong>Laparoscopic Surgery</strong> – Expertise in minimally invasive techniques</li>
    <li><strong>Hernia Repair</strong> – Advanced laparoscopic and open surgical techniques</li>
  </ul>
  <p>
    His clinical acumen extends beyond the operating room, as he actively manages outpatient departments (OPD), ward cases, and surgical screenings to ensure precise diagnosis and treatment.
  </p>

  <h3><strong>Experience and Professional Journey</strong></h3>
  <p>
    Dr. Patil’s career is marked by academic excellence and hands-on surgical experience. He completed his M.S. in General Surgery from Bangalore Medical College and Research Institute and his M.B.B.S. from Karnataka Institute of Medical Sciences. His professional trajectory includes:
  </p>
  <ul>
    <li>Assistant Professor, Vydehi Institute of Medical Sciences (since 2022)</li>
    <li>Senior Resident, Victoria Hospital, Bangalore (2020-2021)</li>
    <li>Surgical Residency, Victoria Hospital & Bowring and Lady Curzon Hospital (3 years)</li>
  </ul>
  <p>
    His role as an educator and mentor ensures that the next generation of surgeons is equipped with the latest knowledge in surgical advancements.
  </p>

  <h3><strong>Research & Academic Contributions</strong></h3>
  <p>
    Dr. Patil is actively involved in clinical research and has published several papers in national and international medical journals, focusing on:
  </p>
  <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
    <li>Laparoscopic Cholecystectomy techniques</li>
    <li>Management of Liver Abscess</li>
    <li>Intestinal Stomas and Postoperative Complications</li>
  </ul>
  <p>
    Additionally, he has presented award-winning scientific papers at prestigious conferences such as ASICON and KSC-ASICON, reflecting his commitment to academic excellence.
  </p>
</div>
    `,
  },
  {
    name: "Dr. Sumeeta Nagaraj",
    dis: (
      <h6 className="pt-2 font-medium">
        Pediatrician | Child Health Specialist | Newborn & Child Care
      </h6>
    ),
    img: "/doctor-images/Dr. Sumeeta Nagaraj.webp",
    rate: "4.8/5",
    exper: "10",
    consultation: "OPD Consultation",
    timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
    link: "/bestpediatricianinwhitefield-by-dr-sumeeta-nagaraj",
    depat: "Pediatrics",
    con: `

      <!-- About -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          About Dr. Sumeeta Nagaraj
        </h2>

        <p class="text-sm text-gray-700">
          Dr. Sumeeta Nagaraj is a dedicated and experienced Pediatrician in
          Channasandra, Whitefield, Bangalore, with a strong focus on comprehensive
          child health care from newborns to adolescents.
        </p>

        <p class="text-sm text-gray-700 mt-2">
          With more than 10 years of clinical experience, she specializes in
          preventive health care, immunizations, growth and development monitoring,
          nutritional guidance, and management of acute and chronic childhood
          illnesses.
        </p>

        <p class="text-sm text-gray-700 mt-2">
          Dr. Sumeeta provides compassionate, evidence-based care, prioritizing the
          overall well-being and healthy development of every child. Her approach
          emphasizes parent education, preventive strategies, and timely
          intervention.
        </p>
      </section>

      <!-- Areas of Expertise -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Areas of Expertise
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Pediatric consultation in Channasandra, Whitefield, Bangalore</li>
          <li>Newborn and infant care</li>
          <li>Immunizations and vaccination guidance</li>
          <li>Nutritional assessment and advice</li>
          <li>Growth and developmental monitoring</li>
          <li>Treatment of childhood infections</li>
          <li>Chronic childhood illness management</li>
          <li>Emergency pediatric care</li>
        </ul>
      </section>

      <!-- Services Provided -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Services Provided
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Regular child health check-ups</li>
          <li>Growth &amp; development assessments</li>
          <li>Immunization and vaccine counseling</li>
          <li>Fever and infection treatment</li>
          <li>Nutritional and feeding advice</li>
          <li>Asthma and allergy management</li>
          <li>Pediatric emergency consultation</li>
        </ul>
      </section>

      <!-- Why Choose -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Why Choose Dr. Sumeeta Nagaraj?
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Experienced Pediatrician in Channasandra, Whitefield, Bangalore</li>
          <li>Child-centered and parent-focused care</li>
          <li>Broad experience in preventive and therapeutic pediatric medicine</li>
          <li>Gentle and compassionate approach to children</li>
          <li>Practicing at a trusted multi-specialty clinic</li>
        </ul>
      </section>

      <!-- Clinic Details -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Clinic Details
        </h2>

        <ul class="text-sm text-gray-700 space-y-1">
          <li><strong>Clinic Name:</strong> ELV Health Care</li>
          <li><strong>Clinic Location:</strong> Channasandra, Whitefield, Bangalore</li>
          <li><strong>Consultation Days:</strong> Monday to Saturday</li>
          <li><strong>Timings:</strong> As per clinic schedule</li>
        </ul>
      </section>

      <!-- Appointment CTA -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Book an Appointment
        </h2>

        <a
          href="https://wa.me/919535264855"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
        >
          📞 WhatsApp / Call: 095352 64855
        </a>
      </section>

      <!-- FAQs -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          FAQs
        </h2>

        <div class="text-sm text-gray-700 space-y-3">
          <div>
            <p class="font-medium">
              Is Dr. Sumeeta Nagaraj a pediatrician in Channasandra, Whitefield, Bangalore?
            </p>
            <p>
              Yes, she is an experienced pediatrician providing child health care
              services at ELV Health Care in Channasandra, Whitefield, Bangalore.
            </p>
          </div>

          <div>
            <p class="font-medium">What age group does she treat?</p>
            <p>
              She treats newborns, infants, children, and adolescents.
            </p>
          </div>

          <div>
            <p class="font-medium">Does she provide vaccination guidance?</p>
            <p>
              Yes, she provides immunization counseling and routine vaccination
              support.
            </p>
          </div>
        </div>
      </section>
  `,
  },

  {
    name: "Dr. Manjunatha B G",
    dis: (
      <h6 className="pt-2 font-medium">
        Pulmonologist | Respiratory Specialist | Sleep & Lung Disease Treatment
      </h6>
    ),
    img: "/doctor-images/Dr. Manjunath B G.webp",
    rate: "4.8/5",
    exper: "15",
    consultation: "OPD Consultation",
    timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
    link: "/bestpulmonologistinwhitefield-by-dr-manjunatha-b-g",
    depat: "Pulmonology / Respiratory Medicine",
    con: `

      <!-- About -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          About Dr. Manjunatha B G
        </h2>

        <p class="text-sm text-gray-700">
          Dr. Manjunatha B G is a highly experienced Pulmonologist in Channasandra,
          Whitefield, Bangalore, specializing in the diagnosis and treatment of
          respiratory and lung diseases. With extensive clinical expertise in
          chronic lung disorders, asthma care, COPD management, interventional
          pulmonology, and sleep-related breathing disorders, he provides
          patient-centric care using the latest evidence-based practices.
        </p>

        <p class="text-sm text-gray-700 mt-2">
          Dr. Manjunatha is known for his comprehensive approach to respiratory
          health, focusing on accurate diagnosis, personalized treatment plans,
          and long-term disease management for improved lung function and quality
          of life.
        </p>
      </section>

      <!-- Areas of Expertise -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Areas of Expertise
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Pulmonology consultation in Channasandra, Whitefield, Bangalore</li>
          <li>Asthma and allergy management</li>
          <li>Chronic Obstructive Pulmonary Disease (COPD) care</li>
          <li>Interstitial lung disease (ILD) treatment</li>
          <li>Bronchoscopy and respiratory procedures</li>
          <li>Sleep-related breathing disorder evaluation</li>
          <li>Infectious lung disease management (pneumonia, TB)</li>
          <li>Smoking-related lung disease management</li>
        </ul>
      </section>

      <!-- Services Provided -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Services Provided
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Pulmonology consultation and assessment</li>
          <li>Lung function tests (Spirometry)</li>
          <li>Bronchoscopy and diagnostic procedures</li>
          <li>Sleep apnea evaluation and therapy</li>
          <li>Management of asthma and COPD</li>
          <li>Treatment for chronic cough and respiratory infections</li>
          <li>Chest infection evaluation and follow-up care</li>
        </ul>
      </section>

      <!-- Why Choose -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Why Choose Dr. Manjunatha B G?
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Expert Pulmonologist in Channasandra, Whitefield, Bangalore</li>
          <li>Comprehensive respiratory care and diagnostics</li>
          <li>Personalized treatment plans tailored to each patient</li>
          <li>Focus on preventive care and long-term lung health</li>
          <li>Practicing at a trusted multi-specialty clinic</li>
        </ul>
      </section>

      <!-- Clinic Details -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Clinic Details
        </h2>

        <ul class="text-sm text-gray-700 space-y-1">
          <li><strong>Clinic Name:</strong> ELV Health Care</li>
          <li><strong>Clinic Location:</strong> Channasandra, Whitefield, Bangalore</li>
          <li><strong>Consultation Days:</strong> Monday to Saturday</li>
          <li><strong>Timings:</strong> As per clinic schedule</li>
        </ul>
      </section>

      <!-- Appointment CTA -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Book an Appointment
        </h2>

        <a
          href="https://wa.me/919535264855"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
        >
          📞 WhatsApp / Call: 095352 64855
        </a>
      </section>

      <!-- FAQs -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          FAQs
        </h2>

        <div class="text-sm text-gray-700 space-y-3">
          <div>
            <p class="font-medium">
              Is Dr. Manjunatha B G a pulmonologist in Channasandra, Whitefield, Bangalore?
            </p>
            <p>
              Yes, he is an experienced pulmonologist providing respiratory care
              at ELV Health Care in Channasandra, Whitefield, Bangalore.
            </p>
          </div>

          <div>
            <p class="font-medium">What conditions does he treat?</p>
            <p>
              He treats asthma, COPD, chronic cough, interstitial lung disease,
              sleep-related breathing disorders, and other lung diseases.
            </p>
          </div>

          <div>
            <p class="font-medium">Does he perform lung diagnostics?</p>
            <p>
              Yes, he provides lung function tests, bronchoscopy, and detailed
              respiratory assessments.
            </p>
          </div>
        </div>
      </section>
  `,
  },

  // {
  //   name: "Dr. Santosh K",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       M.Ch Urology (Gold Medalist), M.S. Surgery, M.B.B.S
  //     </h6>
  //   ),
  //   img: "/doctor-images/Dr. Santosh K.jpg",
  //   rate: "",
  //   exper: "10",
  //   timings: "MON TO SAT - ON APPOINTMENT",
  //   link: "/besturologistinwhitefield-by-dr-santosh-k",
  //   depat: "Urologist",
  //   con: `
  //   <div>
  //     <h2><strong>Dr. Santosh K – Consultant Urologist | Gold Medalist from AIIMS</strong></h2>

  //     <p><strong>Registration:</strong> Karnataka Medical Council – 108891</p>
  //     <p><strong>DOB:</strong> 30-09-1991</p>
  //     <p><strong>Phone:</strong> +91 8800254687 | <strong>Email:</strong> santosh3091@gmail.com</p>
  //     <p><strong>Address:</strong> 106, Raghavendra Classic Sannidhi, Springdale Layout, Vijayanagara, Whitefield, Bangalore – 560066</p>

  //     <h3><strong>Educational Qualifications</strong></h3>
  //     <ul>
  //       <li><strong>M.Ch Urology</strong> – All India Institute of Medical Sciences (AIIMS), Bhubaneswar – Gold Medalist (2020–2022)</li>
  //       <li><strong>M.S. Surgery</strong> – AIIMS, New Delhi (2016–2019)</li>
  //       <li><strong>M.B.B.S</strong> – Mandya Institute of Medical Sciences, Karnataka (2009–2015)</li>
  //     </ul>
  //     <p>
  //       Secured <strong>25th Rank</strong> in the AIIMS Post Graduate Entrance Exam.
  //       Completed MBBS with First Class across all years.
  //       Won 3rd place in the Dermatology Quiz conducted by IADVL (Karnataka region).
  //     </p>

  //     <h3><strong>Current Position</strong></h3>
  //     <p>Consultant Urologist at <strong>Aster Whitefield Hospital, Bangalore</strong> (May 2024 – Present)</p>

  //     <h3><strong>Professional Journey</strong></h3>
  //     <ul>
  //       <li>Consultant, Aster Whitefield Hospital (2024 – Present)</li>
  //       <li>Assistant Professor of Urology, JIPMER Puducherry (Apr 2023 – May 2024)</li>
  //       <li>Senior Resident (Post-M.Ch), AIIMS Bhubaneswar (Jan 2023 – Apr 2023)</li>
  //       <li>Postgraduate & Residency in Surgery, AIIMS New Delhi</li>
  //       <li>Internship – Mandya Institute of Medical Sciences (1-year rotation across departments)</li>
  //     </ul>

  //     <h3><strong>Skills & Expertise</strong></h3>
  //     <ul>
  //       <li>Endourology – URS, PCNL, TURP, stone management</li>
  //       <li>Laparoscopic Urology – Partial nephrectomy, cystectomy, adrenalectomy</li>
  //       <li>Onco-Urology – Prostate, kidney, bladder, and testicular cancers</li>
  //       <li>Reconstructive Urology – Female urethral stricture, VVF repair, pelvic fracture urethral injuries</li>
  //       <li>Renal Transplant Surgery</li>
  //       <li>Critical surgical care & multidisciplinary teamwork</li>
  //     </ul>

  //     <h3><strong>Research & Ongoing Projects</strong></h3>
  //     <ul>
  //       <li>Role of oral Sodium Bicarbonate in reducing intravesical BCG-induced urinary tract symptoms (RCT).</li>
  //       <li>Comparison of laparoscopic intravesical vs extravesical technique for VVF repair (RCT).</li>
  //     </ul>

  //     <h3><strong>Awards & Achievements</strong></h3>
  //     <ul>
  //       <li>Gold Medalist – M.Ch Urology (AIIMS Bhubaneswar)</li>
  //       <li>Travel Fellowship – World Congress of Surgery, Krakow, Poland (2019)</li>
  //       <li>2nd Prize – PG Quiz, Female & Functional Urology Conference, USI (2022)</li>
  //       <li>2nd Prize – Poster Presentation, Female & Functional Urology Conference, USI (2022)</li>
  //       <li>EZUSICON 2021 – 1st Prize (Podium Session)</li>
  //     </ul>

  //     <h3><strong>International & National Presentations</strong></h3>
  //     <ul>
  //       <li>World Congress of Surgery, Poland – Multiple oral & poster presentations</li>
  //       <li>USICON 2022 – Competitive papers & moderated videos on laparoscopic and endourological procedures</li>
  //       <li>ISTSCON 2018 – Endoscopic hemithyroidectomy approaches (Poster)</li>
  //     </ul>

  //     <h3><strong>Publications</strong></h3>
  //     <p>Dr. Santosh has authored and co-authored several papers in reputed journals, including:</p>
  //     <ul>
  //       <li>Indian Journal of Urology (2023) – Pelvic lymph node dissection outcomes in laparoscopic radical cystectomy</li>
  //       <li>BJU International (2023) – IOUS-guided vs conventional laparoscopic nephrectomy</li>
  //       <li>Urology (2022) – Ventral inlay buccal mucosal graft urethroplasty outcomes</li>
  //       <li>Urology Case Reports (2020) – Large adrenal ganglioneuroma excision</li>
  //       <li>Multiple editorials in Indian Journal of Urology (2021–2022)</li>
  //     </ul>

  //     <h3><strong>Professional Memberships</strong></h3>
  //     <ul>
  //       <li>Urological Society of India</li>
  //       <li>Association of Southern Urologists (South Zone Chapter, USI)</li>
  //       <li>East Zone Chapter, Urological Society of India</li>
  //     </ul>

  //     <h3><strong>Languages Known</strong></h3>
  //     <p>English, Hindi, Kannada, Odia, Tamil (receptive)</p>

  //     <h3><strong>Additional Courses & Training</strong></h3>
  //     <ul>
  //       <li>Advanced Trauma Life Support – ATLS India & American College of Surgeons (2017)</li>
  //       <li>Laparoscopic Surgery (Basic & Advanced) – AIIMS</li>
  //       <li>Oncoplastic & Reconstructive Breast Surgery Workshop – World Congress of Surgery (2019)</li>
  //       <li>Basic Course in Biomedical Research – NPTEL (2021)</li>
  //       <li>Workshop on Teaching Skills – AIIMS Bhubaneswar</li>
  //     </ul>

  //     <h3><strong>References</strong></h3>
  //     <ul>
  //       <li>Dr. Sreerag K S – Additional Professor & HOD, Dept. of Urology, JIPMER, Puducherry</li>
  //       <li>Dr. Prasant Nayak – Additional Professor & HOD, Dept. of Urology, AIIMS Bhubaneswar</li>
  //       <li>Dr. Swarnendu Mandal – Associate Professor, Dept. of Urology, AIIMS Bhubaneswar</li>
  //       <li>Dr. Manoj K Das – Associate Professor, Dept. of Urology, AIIMS Bhubaneswar</li>
  //       <li>Prof. Dr. Anita Dhar – Professor, Dept. of Surgical Disciplines, AIIMS New Delhi</li>
  //     </ul>
  //   </div>
  // `,
  // },
  {
    name: "Dr. Pragati Shatapathy",
    dis: (
      <h6 className="pt-2 font-medium">
        Speech & Language Pathologist | Pediatric & Adult Speech Therapy
      </h6>
    ),
    img: "/doctor-images/Dr-Pragati.jpg",
    rate: "4.8/5",
    exper: "10",
    consultation: "OPD Consultation, Speech Therapy Sessions",
    timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
    link: "/speech-language-pathologist-in-bangalore-dr-pragati-shatapathy",
    depat: "Speech & Language Pathology",
    con: `

      <!-- About -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          About Dr. Pragati Shatapathy
        </h2>

        <p class="text-sm text-gray-700">
          Dr. Pragati Shatapathy is an experienced Speech & Language Pathologist in
          Channasandra, Bangalore, with over 10 years of expertise in diagnosing and
          treating speech, language, communication, and swallowing disorders in
          children and adults.
        </p>

        <p class="text-sm text-gray-700 mt-2">
          She provides evidence-based and individualized therapy plans for speech
          delays, language disorders, fluency issues, voice problems, and neurogenic
          communication disorders. Her patient-centric approach focuses on improving
          communication skills and overall quality of life.
        </p>
      </section>

      <!-- Areas of Expertise -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Areas of Expertise
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Speech &amp; language assessment in Channasandra, Bangalore</li>
          <li>Speech delay and language development therapy</li>
          <li>Fluency disorders (stammering / stuttering)</li>
          <li>Voice disorders and voice therapy</li>
          <li>Swallowing disorders (dysphagia)</li>
          <li>Aphasia and cognitive communication therapy</li>
          <li>Pediatric and adult speech therapy</li>
        </ul>
      </section>

      <!-- Services Provided -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Services Provided
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Comprehensive speech and language evaluations</li>
          <li>Individualized speech therapy sessions</li>
          <li>Pediatric speech and language intervention</li>
          <li>Adult speech and voice therapy</li>
          <li>Swallowing assessment and rehabilitation</li>
          <li>Parent and caregiver counselling</li>
        </ul>
      </section>

      <!-- Why Choose -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Why Choose Dr. Pragati Shatapathy?
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Experienced Speech &amp; Language Pathologist in Channasandra, Bangalore</li>
          <li>Expertise in both pediatric and adult speech therapy</li>
          <li>Personalized, evidence-based treatment plans</li>
          <li>Compassionate and patient-friendly approach</li>
          <li>Practicing at a trusted multidisciplinary healthcare clinic</li>
        </ul>
      </section>

      <!-- Clinic Details -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Clinic Details
        </h2>

        <ul class="text-sm text-gray-700 space-y-1">
          <li><strong>Clinic Name:</strong> ELV Health Care</li>
          <li><strong>Clinic Location:</strong> Channasandra, Bangalore</li>
          <li><strong>Consultation Days:</strong> Monday to Saturday</li>
          <li><strong>Timings:</strong> As per clinic schedule</li>
        </ul>
      </section>

      <!-- Appointment CTA -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Book an Appointment
        </h2>

        <a
          href="https://wa.me/919535264855"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
        >
          📞 WhatsApp / Call: 095352 64855
        </a>
      </section>

      <!-- FAQs -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

        <div class="text-sm text-gray-700 space-y-3">
          <div>
            <p class="font-medium">
              Is Dr. Pragati Shatapathy a good Speech Therapist in Channasandra, Bangalore?
            </p>
            <p>
              Yes, she has over 10 years of experience and provides evidence-based
              speech and language therapy for children and adults.
            </p>
          </div>

          <div>
            <p class="font-medium">What conditions does she treat?</p>
            <p>
              She treats speech delay, language disorders, stammering, voice problems,
              swallowing disorders, and neurological communication issues.
            </p>
          </div>

          <div>
            <p class="font-medium">Where does Dr. Pragati Shatapathy consult?</p>
            <p>
              She consults at ELV Health Care, Channasandra, Bangalore.
            </p>
          </div>
        </div>
      </section>
  `,
  },

  {
    name: "Dr. Manika Teotia",
    dis: (
      <h6 className="pt-2 font-medium">
        ENT Specialist | Endoscopic Ear Surgery | PRP Therapy
      </h6>
    ),
    img: "/doctor-images/dr-manika-teotia.jpg",
    rate: "4.7/5",
    exper: "7",
    consultation: "OPD Consultation",
    timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
    link: "/ent-doctor-in-channasandra-bangalore-dr-manika-teotia",
    depat: "ENT (Ear, Nose & Throat)",
    con: `
      <!-- About -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          About Dr. Manika Teotia
        </h2>

        <p class="text-sm text-gray-700">
          Dr. Manika Teotia is an experienced ENT Doctor in Channasandra, Bangalore, with over 7 years
          of clinical expertise in diagnosing and treating ear, nose, and throat disorders. She
          specializes in endoscopic ear surgeries and advanced Platelet Rich Plasma (PRP) therapy for
          conditions such as sensorineural hearing loss (SNHL) and tinnitus.
        </p>

        <p class="text-sm text-gray-700 mt-2">
          She previously worked as a Senior Resident in the ENT Department at Himalayan Institute of
          Medical Sciences, Dehradun, where she managed a wide range of complex ENT cases. Dr. Manika
          follows a patient-centric and evidence-based approach, focusing on accurate diagnosis and
          long-term relief.
        </p>
      </section>

      <!-- Areas of Expertise -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Areas of Expertise
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>ENT consultation in Channasandra, Bangalore</li>
          <li>Endoscopic ear surgery</li>
          <li>Hearing loss evaluation and treatment</li>
          <li>PRP therapy for SNHL</li>
          <li>Tinnitus management</li>
          <li>Ear infections and ear discharge</li>
          <li>Nose and sinus disorders</li>
          <li>Throat and voice problems</li>
        </ul>
      </section>

      <!-- Services Provided -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Services Provided
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>ENT consultations for adults and children</li>
          <li>Treatment for ear pain, ear infections & hearing loss</li>
          <li>PRP therapy for hearing-related conditions</li>
          <li>Endoscopic ear procedures</li>
          <li>Sinusitis and nasal blockage treatment</li>
          <li>Throat infections and voice disorder management</li>
        </ul>
      </section>

      <!-- Why Choose -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Why Choose Dr. Manika Teotia?
        </h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Experienced ENT Specialist in Channasandra, Bangalore</li>
          <li>Expertise in advanced endoscopic and PRP treatments</li>
          <li>Personalized and ethical patient care</li>
          <li>Accurate diagnosis with modern treatment methods</li>
          <li>Practicing at a trusted multi-specialty clinic</li>
        </ul>
      </section>

      <!-- Clinic Details -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Clinic Details
        </h2>

        <ul class="text-sm text-gray-700 space-y-1">
          <li><strong>Clinic Name:</strong> ELV Health Care</li>
          <li><strong>Clinic Location:</strong> Channasandra, Bangalore</li>
          <li><strong>Consultation Days:</strong> Monday to Saturday</li>
          <li><strong>Timings:</strong> As per clinic schedule</li>
        </ul>
      </section>

      <!-- Appointment CTA -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
          Book an Appointment
        </h2>

        <a
          href="https://wa.me/919535264855"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
        >
          📞 WhatsApp / Call: 095352 64855
        </a>
      </section>

      <!-- FAQs -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

        <div class="text-sm text-gray-700 space-y-3">
          <div>
            <p class="font-medium">
              Is Dr. Manika Teotia a good ENT doctor in Channasandra, Bangalore?
            </p>
            <p>
              Yes, she has over 7 years of experience and specializes in advanced ENT treatments,
              including endoscopic ear surgery and PRP therapy.
            </p>
          </div>

          <div>
            <p class="font-medium">What conditions does she treat?</p>
            <p>
              She treats ear infections, hearing loss, tinnitus, sinus issues,
              throat problems, and other ENT conditions.
            </p>
          </div>

          <div>
            <p class="font-medium">Where does Dr. Manika Teotia consult?</p>
            <p>
              She consults at ELV Health Care, Channasandra, Bangalore.
            </p>
          </div>
        </div>
      </section>
  `,
  },

  {
    name: "Dr. Raghavendra Telang",
    dis: (
      <h6 className="pt-2 font-medium">
        General Physician | Primary Care & Emergency Medicine
      </h6>
    ),
    img: "/doctor-images/Dr-Raghavendra-Telang.jpg",
    rate: "4.5/5",
    exper: "1",
    consultation: "OPD Consultation",
    timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
    link: "/general-physician-in-bangalore-dr-raghavendra-telang",
    depat: "General Medicine",
    con: `

      <!-- About -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">About Dr. Raghavendra Telang</h2>

        <p class="text-sm text-gray-700">
          Dr. Raghavendra Telang is a qualified General Physician in Bangalore providing comprehensive medical care for adults.
          He is trained in the diagnosis and management of common medical conditions and has experience in ICU and emergency care.
          His clinical approach focuses on accurate diagnosis, timely treatment, and preventive healthcare.
        </p>

        <p class="text-sm text-gray-700 mt-2">
          He is committed to delivering patient-centric care through evidence-based medicine and clear communication,
          ensuring patients understand their condition and treatment plan.
        </p>
      </section>

      <!-- Areas of Expertise -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Areas of Expertise</h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>General Medicine</li>
          <li>Primary Health Care</li>
          <li>Acute Illness Management</li>
          <li>Chronic Disease Management</li>
          <li>ICU &amp; Emergency Medical Care</li>
          <li>Preventive Health Checkups</li>
        </ul>
      </section>

      <!-- Services Provided -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Services Provided</h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>General medical consultation</li>
          <li>Fever, infections &amp; viral illness treatment</li>
          <li>Diabetes &amp; blood pressure management</li>
          <li>Respiratory and digestive disorders</li>
          <li>Emergency medical care</li>
          <li>Routine health assessments</li>
        </ul>
      </section>

      <!-- Why Choose -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Why Choose Dr. Raghavendra Telang?</h2>

        <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Experienced General Physician in Bangalore</li>
          <li>Patient-focused and ethical medical care</li>
          <li>Accurate diagnosis and personalized treatment</li>
          <li>Support for both acute and chronic conditions</li>
          <li>Practicing at a trusted multi-specialty clinic</li>
        </ul>
      </section>

      <!-- Clinic Details -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Clinic Details</h2>

        <ul class="text-sm text-gray-700 space-y-1">
          <li><strong>Clinic Name:</strong> ELV Health Care</li>
          <li><strong>Location:</strong> Bangalore</li>
          <li><strong>Consultation Days:</strong> Monday to Saturday</li>
          <li><strong>Timings:</strong> As per clinic schedule</li>
        </ul>
      </section>

      <!-- Appointment CTA -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Book an Appointment</h2>

        <a
          href="https://wa.me/919535264855"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
        >
          📞 WhatsApp / Call: 095352 64855
        </a>
      </section>

      <!-- FAQs -->
      <section>
        <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

        <div class="text-sm text-gray-700 space-y-3">
          <div>
            <p class="font-medium">What conditions does Dr. Raghavendra Telang treat?</p>
            <p>
              He treats common illnesses, infections, lifestyle diseases, and provides emergency and primary medical care.
            </p>
          </div>

          <div>
            <p class="font-medium">Where does Dr. Raghavendra Telang practice?</p>
            <p>He practices at ELV Health Care, Bangalore.</p>
          </div>

          <div>
            <p class="font-medium">Does he handle emergency cases?</p>
            <p>Yes, he has experience in ICU and emergency medical care.</p>
          </div>
        </div>
      </section>
  `,
  },
  {
    name: "Dr. Vaishnavi S",
    dis: (
      <h6 className="pt-2 font-medium">
        Dermatologist | Cosmetologist | Dermatosurgeon
      </h6>
    ),
    img: "/doctor-images/Dr-Vaishnavi-S.jpeg",
    rate: "4.9/5",
    exper: "9",
    consultation: "Dermatology Consultation",
    timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
    link: "/dermatologist-in-bangalore-dr-vaishnavi-s",
    depat: "Dermatology",
    con: `

    <!-- About -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">About Dr. Vaishnavi S</h2>

      <p class="text-sm text-gray-700">
        Dr. Vaishnavi S is an experienced Dermatologist, Cosmetologist, and Dermatosurgeon
        with expertise in clinical dermatology, aesthetic skin treatments, laser procedures,
        and dermatosurgery. She has 9 years of overall experience, including 2 years as a specialist,
        and is known for providing personalized and evidence-based skin, hair, and cosmetic treatments.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        She completed her MBBS from Rajiv Gandhi University of Health Sciences in 2017,
        MD in Dermatology, Venereology & Leprosy from Rajiv Gandhi University of Health Sciences in 2023,
        and DNB in Dermatology, Venereology & Leprosy from the National Board of Examinations in 2024.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        Dr. Vaishnavi S has also completed a Fellowship in Dermatosurgery at St. John's Hospital, Bangalore.
        She focuses on advanced skin rejuvenation, acne scar management, pigmentation treatment,
        laser procedures, PRP therapy, and cosmetic dermatology with a patient-centric approach.
      </p>
    </section>

    <!-- Areas of Expertise -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Areas of Expertise</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Clinical Dermatology</li>
        <li>Cosmetic Dermatology</li>
        <li>Dermatosurgery</li>
        <li>Laser Skin Treatments</li>
        <li>Acne & Acne Scar Management</li>
        <li>Pigmentation & Tan Removal</li>
        <li>PRP Hair & Skin Treatments</li>
        <li>Anti-Aging Procedures</li>
        <li>Scar & Keloid Treatment</li>
        <li>Skin Rejuvenation Procedures</li>
      </ul>
    </section>

    <!-- Services Provided -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Services Provided</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Tattoo Removal</li>
        <li>PRP Treatment</li>
        <li>Derma Roller for Acne Scars & Stretch Marks</li>
        <li>Tan Removal Treatments</li>
        <li>Keloid & Scar Treatment</li>
        <li>Sun Spots & Pigmented Lesion Treatment</li>
        <li>Chemical Peel Procedures</li>
        <li>Botox Injections</li>
        <li>Laser Resurfacing</li>
        <li>Laser Hair Removal - Face</li>
        <li>Dermabrasion</li>
        <li>Skin Lightening & Skin Whitening Treatments</li>
        <li>Wart Removal</li>
        <li>Acne Scar Treatment</li>
        <li>Advanced Cosmetic Skin Procedures</li>
      </ul>
    </section>

    <!-- Why Choose -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Why Choose Dr. Vaishnavi S?</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Experienced Dermatologist and Dermatosurgeon in Bangalore</li>
        <li>Specialized expertise in cosmetic and laser dermatology</li>
        <li>Advanced treatments for acne scars, pigmentation, and anti-aging</li>
        <li>Evidence-based and personalized treatment plans</li>
        <li>Focus on safe, effective, and minimally invasive procedures</li>
        <li>Fellowship-trained in Dermatosurgery</li>
        <li>Compassionate and patient-focused approach to skincare</li>
      </ul>
    </section>

    <!-- Education -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Education & Qualifications</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>MBBS - Rajiv Gandhi University of Health Sciences (2017)</li>
        <li>MD - Dermatology, Venereology & Leprosy - Rajiv Gandhi University of Health Sciences (2023)</li>
        <li>DNB - Dermatology, Venereology & Leprosy - National Board Of Examinations (2024)</li>
        <li>Fellowship in Dermatosurgery - St. John's Hospital, Bangalore (2023 - 2024)</li>
      </ul>
    </section>

    <!-- Awards -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Awards & Recognitions</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Cuticon - 2022</li>
        <li>Mid Dermacon - 2021</li>
        <li>International Leprosy Congress - 2022</li>
        <li>IDC, Tokyo - 2022</li>
      </ul>
    </section>

    <!-- Memberships -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Professional Memberships</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>IADVL (Indian Association of Dermatologists, Venereologists and Leprologists)</li>
      </ul>
    </section>

    <!-- Conditions Treated -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Conditions Treated</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Acne and Acne Scars</li>
        <li>Hair Fall & Hair Thinning</li>
        <li>Pigmentation and Tanning</li>
        <li>Stretch Marks</li>
        <li>Keloids and Scars</li>
        <li>Sun Damage and Age Spots</li>
        <li>Warts and Skin Growths</li>
        <li>Skin Aging Concerns</li>
        <li>Uneven Skin Tone</li>
        <li>Cosmetic Skin Concerns</li>
      </ul>
    </section>

    <!-- Clinic Details -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Clinic Details</h2>

      <ul class="text-sm text-gray-700 space-y-1">
        <li><strong>Consultation Days:</strong> Monday to Saturday</li>
        <li><strong>Timings:</strong> As per clinic schedule</li>
        <li><strong>Registration:</strong> Karnataka Medical Council - 131619 (2019)</li>
      </ul>
    </section>

    <!-- Appointment CTA -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Book an Appointment</h2>

      <a
        href="https://wa.me/919535264855"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-block bg-pink-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-pink-700 transition"
      >
        📞 WhatsApp / Call: 095352 64855
      </a>
    </section>

    <!-- FAQs -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

      <div class="text-sm text-gray-700 space-y-3">

        <div>
          <p class="font-medium">What are Dr. Vaishnavi S’s specialties?</p>
          <p>
            Dr. Vaishnavi S specializes in Dermatology, Cosmetology, and Dermatosurgery.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Vaishnavi S provide acne scar treatments?</p>
          <p>
            Yes, she provides advanced acne scar treatments including derma roller procedures,
            chemical peels, laser resurfacing, and scar management therapies.
          </p>
        </div>

        <div>
          <p class="font-medium">Does she offer cosmetic dermatology procedures?</p>
          <p>
            Yes, she offers cosmetic procedures including Botox, skin rejuvenation,
            laser treatments, pigmentation correction, and skin lightening treatments.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Vaishnavi S provide PRP treatments?</p>
          <p>
            Yes, PRP therapy for hair and skin rejuvenation is one of the services provided by her.
          </p>
        </div>

        <div>
          <p class="font-medium">Is laser treatment available?</p>
          <p>
            Yes, she provides laser resurfacing, laser hair removal, and other advanced laser procedures.
          </p>
        </div>

      </div>
    </section>
`,
  },
  {
    name: "Dr. Santosh K",
    dis: (
      <h6 className="pt-2 font-medium">
        Associate Consultant - Urology & Renal Transplantation
      </h6>
    ),
    img: "/doctor-images/Dr. Santosh.jpg.webp",
    rate: "4.9/5",
    exper: "10",
    consultation: "Urology Consultation",
    timings: "MON TO SAT - AS PER HOSPITAL SCHEDULE",
    link: "/urologist-in-bangalore-dr-santosh-k",
    depat: "Urology",
    con: `

    <!-- About -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">About Dr. Santosh K</h2>

      <p class="text-sm text-gray-700">
        Dr. Santosh K is a highly skilled Urologist and Renal Transplant Specialist
        currently serving as Associate Consultant - Urology and Renal Transplantation
        at Aster Whitefield Hospital, Bangalore.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        He completed his MBBS from Mandya Institute of Medical Sciences, Mandya,
        followed by MS in General Surgery from the prestigious AIIMS New Delhi.
        He later pursued MCh in Urology from AIIMS Bhubaneswar.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        Prior to joining Aster Whitefield Hospital, he worked as Assistant Professor
        at JIPMER, Puducherry. With a strong academic background and extensive
        surgical expertise, Dr. Santosh specializes in advanced urological procedures,
        minimally invasive surgeries, robotic urology, laser surgeries, reconstructive
        urology, and renal transplantation.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        Dr. Santosh K is actively involved in academic research and has authored
        over 17 publications in reputed national and international peer-reviewed journals.
        He has also presented research papers and award-winning presentations
        at several prestigious national and international conferences.
      </p>
    </section>

    <!-- Areas of Expertise -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Areas of Expertise</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Endo-Urology</li>
        <li>LASER Prostate Surgery (HOLEP)</li>
        <li>LASER Kidney Stone Surgery (RIRS, PCNL)</li>
        <li>Robotic & Laparoscopic Urology</li>
        <li>Urological Oncology</li>
        <li>Reconstructive Urology</li>
        <li>Male Infertility and Sexual Health</li>
        <li>Neurourology & Urodynamic Study</li>
        <li>Stapler Circumcision</li>
        <li>AV Fistula Surgery</li>
        <li>Renal Transplantation</li>
      </ul>
    </section>

    <!-- Services -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Services Provided</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Laser kidney stone surgeries</li>
        <li>RIRS and PCNL procedures</li>
        <li>HOLEP laser prostate surgery</li>
        <li>Robotic urology surgeries</li>
        <li>Laparoscopic urology surgeries</li>
        <li>Kidney transplant surgeries</li>
        <li>Urological cancer surgeries</li>
        <li>Male infertility treatment</li>
        <li>Sexual health consultation</li>
        <li>Urethral reconstruction procedures</li>
        <li>Female urology treatments</li>
        <li>Neurourology evaluation and management</li>
        <li>Urodynamic studies</li>
        <li>Stapler circumcision procedures</li>
        <li>AV fistula surgeries</li>
        <li>Minimally invasive urological procedures</li>
      </ul>
    </section>

    <!-- Why Choose -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Why Choose Dr. Santosh K?</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Trained at premier institutes including AIIMS New Delhi and AIIMS Bhubaneswar</li>
        <li>Expertise in advanced laser, robotic, and minimally invasive urological procedures</li>
        <li>Specialized care for kidney stones, prostate disorders, infertility, and cancers</li>
        <li>Experienced in renal transplantation and reconstructive urology</li>
        <li>Strong academic and research background</li>
        <li>Published author in reputed international journals</li>
        <li>Patient-centered and evidence-based treatment approach</li>
      </ul>
    </section>

    <!-- Education -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Education & Qualifications</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>MBBS - Mandya Institute of Medical Sciences, Mandya</li>
        <li>MS (General Surgery) - AIIMS New Delhi</li>
        <li>MCh (Urology) - AIIMS Bhubaneswar</li>
      </ul>
    </section>

    <!-- Experience -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Professional Experience</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Associate Consultant - Urology & Renal Transplantation at Aster Whitefield Hospital, Bangalore</li>
        <li>Assistant Professor at JIPMER, Puducherry</li>
      </ul>
    </section>

    <!-- Awards -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Awards & Recognitions</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Travel Fellowship by the International Society of Surgery - 2019</li>
        <li>2nd Prize - PG Quiz, Female & Functional Urology Subsection Conference of the Urological Society of India (2022)</li>
        <li>2nd Prize - Poster Presentation, Female & Functional Urology Subsection Conference of the Urological Society of India (2022)</li>
        <li>EZUSICON 2021 - Podium Session 1st Prize</li>
      </ul>
    </section>

    <!-- Memberships -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Professional Memberships</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Urological Society of India (Life Member K-514)</li>
        <li>East Zone Chapter - Urological Society of India (Life Member)</li>
        <li>South Zone Chapter - Urological Society of India (Life Member)</li>
        <li>Association of Surgeons of India (Life Member)</li>
      </ul>
    </section>

    <!-- Conference Presentations -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Conference Presentations</h2>

      <div class="text-sm text-gray-700 space-y-3">

        <div>
          <p class="font-medium">ISTSCON - Tata Memorial Hospital (2018)</p>
          <p>
            Poster Presentation: Comparison of trans-oral vestibular and axillary breast approaches of endoscopic hemithyroidectomy.
          </p>
        </div>

        <div>
          <p class="font-medium">World Congress of Surgery - Krakow, Poland (2019)</p>
          <p>
            Podium Presentation: Comparison of efficacy of Ormeloxifene and Tamoxifen in cyclical mastalgia.
          </p>
        </div>

        <div>
          <p class="font-medium">World Congress of Surgery - Krakow, Poland (2019)</p>
          <p>
            Randomized study comparing compression bandage systems in venous ulcer treatment.
          </p>
        </div>

        <div>
          <p class="font-medium">EZUSICON 2021</p>
          <p>
            1st Prize Podium Session: Tubularized anterior bladder flap urethral reconstruction for female pelvic fracture long-segment urethral injury.
          </p>
        </div>

        <div>
          <p class="font-medium">EZUSICON 2021</p>
          <p>
            Moderated Video: Laparoscopic Partial Nephrectomy in Right Hilar Renal Mass.
          </p>
        </div>

        <div>
          <p class="font-medium">USICON 2022</p>
          <p>
            Moderated Video Session: Percutaneous management of recurrent renal fungal ball mimicking staghorn calculus.
          </p>
        </div>

        <div>
          <p class="font-medium">SZUSICON 2022</p>
          <p>
            Long-term follow-up and success rate of ventral inlay buccal mucosal graft urethroplasty.
          </p>
        </div>

        <div>
          <p class="font-medium">FFUS Conference 2022</p>
          <p>
            Comparison of laparoscopic transvesical and intravesical repair of vesicovaginal fistulae.
          </p>
        </div>

        <div>
          <p class="font-medium">USICON 2022</p>
          <p>
            Best Paper Category: Comparison of operative outcomes in laparoscopic radical cystectomy.
          </p>
        </div>

        <div>
          <p class="font-medium">USICON 2022</p>
          <p>
            Podium Presentation: Description of adrenal vasculature and correlation with tumor size and pathology.
          </p>
        </div>

        <div>
          <p class="font-medium">USICON 2022</p>
          <p>
            Moderated Video Presentation: Laparoscopic radical nephrectomy in large T2 tumors.
          </p>
        </div>

        <div>
          <p class="font-medium">South Zone Mid Term CME (2024)</p>
          <p>
            Invited Talk on open and minimally invasive techniques of Boari flap reconstruction.
          </p>
        </div>

      </div>
    </section>

    <!-- Research Publications -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Research Publications</h2>

      <p class="text-sm text-gray-700">
        Dr. Santosh K has published multiple research articles in reputed journals including
        Indian Journal of Urology, Urology, Urolithiasis, BJU International,
        Indian Journal of Surgery, and Urology Case Reports.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        His publications focus on laparoscopic urology, reconstructive procedures,
        bladder cancer, urethral reconstruction, urothelial cancers,
        kidney surgeries, venous thromboembolism prophylaxis,
        nephrectomy techniques, and advanced urological oncology.
      </p>
    </section>

    <!-- Languages -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Languages Spoken</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>English</li>
        <li>Hindi</li>
        <li>Kannada</li>
        <li>Odiya</li>
      </ul>
    </section>

    <!-- Hospital -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Hospital Details</h2>

      <ul class="text-sm text-gray-700 space-y-1">
        <li><strong>Hospital:</strong> Aster Whitefield Bangalore</li>
        <li><strong>Department:</strong> Urology</li>
        <li><strong>Consultation Days:</strong> Monday to Saturday</li>
        <li><strong>Timings:</strong> As per hospital schedule</li>
      </ul>
    </section>

    <!-- Appointment -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Book an Appointment</h2>

      <a
        href="tel:+919535264855"
        class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
      >
        📞 Call Now to Book Appointment
      </a>
    </section>

    <!-- FAQs -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

      <div class="text-sm text-gray-700 space-y-3">

        <div>
          <p class="font-medium">What are Dr. Santosh K’s specialties?</p>
          <p>
            Dr. Santosh K specializes in Urology, Renal Transplantation,
            Endo-Urology, Laser Prostate Surgery, Kidney Stone Surgery,
            Robotic Urology, and Reconstructive Urology.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Santosh K perform laser kidney stone surgeries?</p>
          <p>
            Yes, he performs advanced laser kidney stone surgeries including RIRS and PCNL.
          </p>
        </div>

        <div>
          <p class="font-medium">Does he treat prostate enlargement?</p>
          <p>
            Yes, he specializes in HOLEP laser prostate surgery for enlarged prostate conditions.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Santosh K perform robotic and laparoscopic surgeries?</p>
          <p>
            Yes, he is experienced in robotic and minimally invasive laparoscopic urological procedures.
          </p>
        </div>

        <div>
          <p class="font-medium">Where does Dr. Santosh K practice?</p>
          <p>
            He practices at Aster Whitefield Bangalore.
          </p>
        </div>

      </div>
    </section>
`,
  },

  {
    name: "Dr. Sumeet Kumar",
    dis: (
      <h6 className="pt-2 font-medium">
        Associate Consultant – Surgical Gastroenterology, HPB & General Surgery
      </h6>
    ),
    img: "/doctor-images/dr-sumeet-kumar.jpg",
    rate: "4.8/5",
    exper: "6",
    consultation: "Surgical Gastroenterology Consultation",
    timings: "MON TO SAT - AS PER HOSPITAL SCHEDULE",
    link: "/surgical-gastroenterologist-in-bangalore-dr-sumeet-kumar",
    depat: "Surgical Gastroenterology",
    con: `

    <!-- About -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">About Dr. Sumeet Kumar</h2>

      <p class="text-sm text-gray-700">
        Dr. Sumeet Kumar is a dedicated Surgical Gastroenterologist with expertise
        in Surgical Gastroenterology, Hepato-Pancreato-Biliary (HPB) Surgery,
        and General Surgery. With over 6 years of experience, he is known for his
        detail-oriented and patient-centric approach in managing complex gastrointestinal,
        liver, pancreas, colorectal, and abdominal surgical conditions.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        He specializes in performing both open and minimally invasive surgical procedures
        with a focus on accurate diagnosis, surgical precision, and comprehensive peri-operative care.
        Dr. Sumeet has successfully managed a wide spectrum of elective and emergency surgical cases
        with consistently positive clinical outcomes.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        Apart from clinical practice, Dr. Sumeet Kumar is actively involved in academics
        and research and remains committed to delivering safe, ethical,
        and compassionate surgical care to his patients.
      </p>
    </section>

    <!-- Areas of Expertise -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Areas of Expertise</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Surgical Gastroenterology for Upper GI & Colorectal Conditions</li>
        <li>Hepato-Pancreato-Biliary (HPB) Surgery</li>
        <li>Gall Bladder Surgery</li>
        <li>Liver & Pancreatic Disorder Management</li>
        <li>Advanced Laparoscopic & Minimally Invasive Surgeries</li>
        <li>Breast Surgery</li>
        <li>Thyroid Surgery</li>
        <li>Complex Hernia Surgery & Abdominal Wall Reconstruction</li>
        <li>Emergency & Trauma-related Surgical Interventions</li>
        <li>General Surgical Procedures</li>
      </ul>
    </section>

    <!-- Services -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Services Provided</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Laparoscopic gastrointestinal surgeries</li>
        <li>Gall bladder stone surgery</li>
        <li>Liver and pancreatic surgeries</li>
        <li>Colorectal surgeries</li>
        <li>Appendix surgery</li>
        <li>Hernia repair and abdominal wall reconstruction</li>
        <li>Breast lump and breast surgeries</li>
        <li>Thyroid surgeries</li>
        <li>Emergency abdominal surgeries</li>
        <li>Trauma and emergency surgical care</li>
        <li>Minimally invasive gastrointestinal procedures</li>
        <li>Comprehensive surgical consultation and treatment</li>
      </ul>
    </section>

    <!-- Why Choose -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Why Choose Dr. Sumeet Kumar?</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Experienced Surgical Gastroenterologist with expertise in HPB surgery</li>
        <li>Specialized in advanced laparoscopic and minimally invasive procedures</li>
        <li>Comprehensive care for gastrointestinal, liver, pancreas, and colorectal disorders</li>
        <li>Patient-focused and ethical surgical treatment approach</li>
        <li>Experienced in handling emergency and trauma surgical cases</li>
        <li>Strong academic and research involvement</li>
        <li>Focus on safe surgery and faster patient recovery</li>
      </ul>
    </section>

    <!-- Education -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Education & Qualifications</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>MBBS – JJMMC, Davanagere</li>
        <li>MS – General Surgery – AIMS, Mandya</li>
        <li>Fellowship in Surgical Gastroenterology – KIMS, Hubballi (RGUHS, 2023)</li>
        <li>FSGE</li>
        <li>FIAGES</li>
      </ul>
    </section>

    <!-- Conditions Treated -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Conditions Treated</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Gall bladder stones and gall bladder diseases</li>
        <li>Liver disorders</li>
        <li>Pancreatic conditions</li>
        <li>Colorectal disorders</li>
        <li>Upper gastrointestinal diseases</li>
        <li>Complex hernias</li>
        <li>Breast disorders</li>
        <li>Thyroid disorders</li>
        <li>Emergency abdominal conditions</li>
        <li>Trauma-related surgical conditions</li>
      </ul>
    </section>

    <!-- Languages -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Languages Known</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>English</li>
        <li>Kannada</li>
        <li>Hindi</li>
        <li>Telugu</li>
        <li>Marathi</li>
      </ul>
    </section>

    <!-- Appointment -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Book an Appointment</h2>

      <a
        href="tel:+919535264855"
        class="inline-block bg-green-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-green-700 transition"
      >
        📞 Call Now to Book Appointment
      </a>
    </section>

    <!-- FAQs -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

      <div class="text-sm text-gray-700 space-y-3">

        <div>
          <p class="font-medium">What are Dr. Sumeet Kumar’s specialties?</p>
          <p>
            Dr. Sumeet Kumar specializes in Surgical Gastroenterology,
            Hepato-Pancreato-Biliary (HPB) Surgery, and General Surgery.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Sumeet Kumar perform laparoscopic surgeries?</p>
          <p>
            Yes, he specializes in advanced laparoscopic and minimally invasive surgical procedures.
          </p>
        </div>

        <div>
          <p class="font-medium">Does he treat gall bladder and liver disorders?</p>
          <p>
            Yes, he provides surgical treatment for gall bladder, liver,
            pancreatic, and other gastrointestinal conditions.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Sumeet Kumar perform hernia surgeries?</p>
          <p>
            Yes, he performs complex hernia surgeries and abdominal wall reconstruction procedures.
          </p>
        </div>

        <div>
          <p class="font-medium">Is emergency surgical care available?</p>
          <p>
            Yes, he is experienced in emergency and trauma-related surgical interventions.
          </p>
        </div>

      </div>
    </section>
`,
  },
  {
    name: "Dr. Ravikiran Andra",
    dis: (
      <h6 className="pt-2 font-medium">
        Specialist – General, Laparoscopic & Minimal Access Surgery
      </h6>
    ),
    img: "/doctor-images/Dr Ravikiran H V.jpg",
    rate: "4.9/5",
    exper: "8",
    consultation: "General & Laparoscopic Surgery Consultation",
    timings: "MON TO SAT - AS PER HOSPITAL SCHEDULE",
    link: "/general-laparoscopic-surgeon-in-bangalore-dr-ravikiran-andra",
    depat: "General & Laparoscopic Surgery",
    con: `

    <!-- About -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">About Dr. Ravikiran Andra</h2>

      <p class="text-sm text-gray-700">
        Dr. Ravikiran Andra is a highly skilled General and Laparoscopic Surgeon
        currently practising as Specialist – General, Laparoscopic & Minimal Access Surgery
        at Manipal Hospital Varthur Road, Bangalore.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        With extensive expertise in conventional and minimally invasive surgical techniques,
        Dr. Ravikiran provides comprehensive surgical care focused on patient comfort,
        safety, precision, faster recovery, and evidence-based treatment outcomes.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        He completed his MBBS from Vydehi Institute of Medical Sciences, Bengaluru,
        followed by MS in General Surgery from Jawaharlal Nehru Medical College, Belagavi,
        and later earned DNB in General Surgery. He further enhanced his expertise
        by completing Fellowship in Minimal Access Surgery (FMAS) from AMASI.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        Dr. Ravikiran specializes in laparoscopic surgeries, gastrointestinal procedures,
        hernia repairs, colorectal surgeries, breast surgeries, thyroid surgeries,
        proctology procedures, trauma care, and minimally invasive surgical interventions.
      </p>

      <p class="text-sm text-gray-700 mt-2">
        He is also actively involved in academic research, conference presentations,
        surgical outreach camps, and professional development through national
        and international surgical organizations.
      </p>
    </section>

    <!-- Areas of Expertise -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Field of Expertise</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Minimally Invasive & Laparoscopic Surgery</li>
        <li>Laparoscopic Gallbladder Surgery (Cholecystectomy)</li>
        <li>Hernia Surgery - Laparoscopic (TEP, IPOM, Ventral, Umbilical) & Open Repairs</li>
        <li>Appendix Surgery (Appendicectomy)</li>
        <li>Anti-reflux Surgery (Laparoscopic Fundoplication for GERD/Hiatal Hernia)</li>
        <li>Gastrointestinal & Colorectal Procedures</li>
        <li>Breast Surgery (Lumpectomy & Mastectomy)</li>
        <li>Thyroid Surgery</li>
        <li>Piles, Fistula in Ano & Pilonidal Sinus Surgery</li>
        <li>Minor OPD Procedures (Cyst, Lipoma, Abscess, Wound Care)</li>
        <li>Trauma Care & Emergency Surgical Management</li>
      </ul>
    </section>

    <!-- Services -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Services Provided</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Laparoscopic gallbladder removal surgery</li>
        <li>Appendix surgery (Appendicectomy)</li>
        <li>Laparoscopic and open hernia repair surgeries</li>
        <li>Laparoscopic fundoplication surgery for GERD & hiatal hernia</li>
        <li>Colorectal and gastrointestinal surgeries</li>
        <li>Breast surgeries for benign and malignant conditions</li>
        <li>Thyroid surgeries</li>
        <li>Piles, fistula, and pilonidal sinus surgeries</li>
        <li>Minor OPD procedures including cyst and lipoma removal</li>
        <li>Abscess drainage and wound care management</li>
        <li>Emergency and trauma surgical interventions</li>
        <li>Advanced minimally invasive surgeries</li>
      </ul>
    </section>

    <!-- Why Choose -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Why Choose Dr. Ravikiran Andra?</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Experienced specialist in general and laparoscopic surgery</li>
        <li>Advanced expertise in minimal access surgical techniques</li>
        <li>Patient-centric and evidence-based surgical care</li>
        <li>Expert in gastrointestinal, hernia, breast, and thyroid surgeries</li>
        <li>Focus on minimally invasive procedures for faster recovery</li>
        <li>International exposure through memberships and academic conferences</li>
        <li>Strong research and academic background with award-winning presentations</li>
      </ul>
    </section>

    <!-- Education -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Education & Qualifications</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>MBBS - Vydehi Institute of Medical Sciences, Bengaluru</li>
        <li>MS (General Surgery) - Jawaharlal Nehru Medical College, Belagavi</li>
        <li>DNB (General Surgery)</li>
        <li>FMAS - Fellowship in Minimal Access Surgery (AMASI)</li>
      </ul>
    </section>

    <!-- Fellowship & Membership -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Fellowship & Memberships</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Fellowship in Minimal Access Surgery (FMAS) - AMASI</li>
        <li>Life Member - Association of Surgeons of India (ASI)</li>
        <li>Life Member - Indian Association of Gastrointestinal Endo-Surgeons (IAGES)</li>
        <li>Life Member - Association of Minimal Access Surgeons of India (AMASI)</li>
        <li>Surgeon Member - Obesity & Metabolic Surgery Society of India (OSSI)</li>
        <li>Physician Member - European Association for Endoscopic Surgery (EAES)</li>
      </ul>
    </section>

    <!-- Awards -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Awards & Achievements</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Advanced Trauma Life Support (ATLS) - American College of Surgeons</li>
        <li>Best Free Paper Award - ASICON 2022, Mumbai</li>
        <li>Best Poster Award - ASICON 2021</li>
        <li>Multiple publications in indexed journals on hernia repair, laparoscopic GI surgery & rare surgical cases</li>
      </ul>
    </section>

    <!-- Research & Publications -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Talks & Publications</h2>

      <div class="text-sm text-gray-700 space-y-3">

        <div>
          <p class="font-medium">ASICON 2022, Mumbai</p>
          <p>
            Presented research on Intra-abdominal Adhesions and received the Best Free Paper Award.
          </p>
        </div>

        <div>
          <p class="font-medium">ASICON 2021</p>
          <p>
            Poster presentation on Minimally Invasive Surgery in Pheochromocytoma and received the Best Poster Award.
          </p>
        </div>

        <div>
          <p class="font-medium">Case Reports & Publications</p>
          <p>
            Published research and case reports on rare diaphragmatic hernia with gastric volvulus,
            isolated splenic hydatid cyst, choledochal cyst excision with Roux-en-Y hepaticojejunostomy,
            recurrent fistula in ano, and minimally invasive management of carcinoma oesophagus.
          </p>
        </div>

        <div>
          <p class="font-medium">Journal Contributions</p>
          <p>
            Co-author of journal articles on hernia repair techniques and laparoscopic innovations.
          </p>
        </div>

        <div>
          <p class="font-medium">National Conferences</p>
          <p>
            Presenter at national surgical conferences including ASICON, HSICON, and SELSICON.
          </p>
        </div>

      </div>
    </section>

    <!-- Conditions Treated -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Conditions Treated</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>Gallbladder stones and gallbladder diseases</li>
        <li>Hernias (Inguinal, Umbilical, Ventral & Incisional)</li>
        <li>Appendicitis</li>
        <li>GERD & Hiatal Hernia</li>
        <li>Colorectal disorders</li>
        <li>Breast lumps and breast cancer conditions</li>
        <li>Thyroid disorders</li>
        <li>Piles and fistula in ano</li>
        <li>Pilonidal sinus</li>
        <li>Trauma and emergency surgical conditions</li>
      </ul>
    </section>

    <!-- Languages -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Languages Spoken</h2>

      <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
        <li>English</li>
        <li>Telugu</li>
        <li>Kannada</li>
        <li>Hindi</li>
        <li>Marathi</li>
        <li>Bengali</li>
      </ul>
    </section>

  

    <!-- Appointment -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">Book an Appointment</h2>

      <a
        href="tel:+919535264855"
        class="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition"
      >
        📞 Call Now to Book Appointment
      </a>
    </section>

    <!-- FAQs -->
    <section>
      <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">FAQs</h2>

      <div class="text-sm text-gray-700 space-y-3">

        <div>
          <p class="font-medium">What are Dr. Ravikiran Andra’s specialties?</p>
          <p>
            Dr. Ravikiran specializes in General Surgery, Laparoscopic Surgery,
            Minimal Access Surgery, Gastrointestinal Surgery, Hernia Surgery,
            Breast Surgery, Thyroid Surgery, and Proctology procedures.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Ravikiran perform laparoscopic surgeries?</p>
          <p>
            Yes, he is highly experienced in advanced laparoscopic and minimally invasive surgeries.
          </p>
        </div>

        <div>
          <p class="font-medium">Does he treat hernias and gallbladder problems?</p>
          <p>
            Yes, he performs laparoscopic and open hernia repairs as well as gallbladder surgeries.
          </p>
        </div>

        <div>
          <p class="font-medium">Does Dr. Ravikiran treat piles and fistula?</p>
          <p>
            Yes, he provides advanced treatment for piles, fistula in ano, and pilonidal sinus conditions.
          </p>
        </div>
      </div>
    </section>
`,
  },

  // {
  //   name: "Dr. Shreesha Marla",
  //   dis: (
  //     <h6 className="pt-2 font-medium">
  //       Consultant Obstetrician & Gynaecologist
  //     </h6>
  //   ),
  //   img: "/doctor-images/Dr-Shreesha-Marla.jpg",
  //   rate: "4.8/5",
  //   exper: "8",
  //   consultation: "OBG Consultation",
  //   timings: "MON TO SAT - AS PER CLINIC SCHEDULE",
  //   link: "/consultant-obstetrician-gynaecologist-in-bangalore-dr-shreesha-marla",
  //   depat: "Obstetrics & Gynaecology",
  //   con: `

  //     <!-- About -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Dr. Shreesha Marla – Consultant Obstetrician & Gynaecologist at ELV Healthcare
  //       </h2>

  //       <p class="text-sm text-gray-700">
  //         Dr. Shreesha Marla is a highly qualified and compassionate Consultant Obstetrician and Gynaecologist at ELV Healthcare, with extensive experience in managing comprehensive women’s health needs across all stages of life. She is dedicated to providing evidence-based, ethical, and patient-centric care with a strong focus on maternal and gynecological wellbeing.
  //       </p>

  //       <p class="text-sm text-gray-700 mt-2">
  //         With advanced training in obstetrics, gynecology, and minimally invasive procedures, Dr. Shreesha Marla combines clinical excellence with empathy to ensure safe outcomes for both mother and child.
  //       </p>
  //     </section>

  //     <!-- Qualifications & Credentials -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Qualifications & Credentials
  //       </h2>

  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
  //         <li>MBBS</li>
  //         <li>MS – Obstetrics & Gynaecology</li>
  //         <li>DNB – Obstetrics & Gynaecology</li>
  //         <li>MRCOG Part 1 (UK)</li>
  //         <li>PGDMLE</li>
  //         <li>Certified BLS & ACLS Provider</li>
  //       </ul>
  //     </section>

  //     <!-- Clinical Expertise & Special Interests -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Clinical Expertise & Special Interests
  //       </h2>

  //       <p class="text-sm text-gray-700">
  //         Dr. Shreesha Marla specializes in the diagnosis, treatment, and management of a wide range of obstetric and gynecological conditions, including:
  //       </p>

  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1 mt-2">
  //         <li>High-risk and low-risk pregnancy care</li>
  //         <li>Normal delivery & Caesarean section (LSCS)</li>
  //         <li>Antenatal, intrapartum & postnatal care</li>
  //         <li>Menstrual disorders & hormonal imbalance</li>
  //         <li>PCOS & infertility evaluation</li>
  //         <li>Laparoscopic gynecological surgeries</li>
  //         <li>Hysterectomy (vaginal & abdominal)</li>
  //         <li>Fibroids, ovarian cysts & endometriosis</li>
  //         <li>IUCD insertion & family planning services</li>
  //         <li>Colposcopy, cryotherapy & cervical screening</li>
  //       </ul>
  //     </section>

  //     <!-- Surgical & Procedural Experience -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Surgical & Procedural Experience
  //       </h2>

  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
  //         <li>Vaginal deliveries and labour monitoring</li>
  //         <li>Caesarean sections (LSCS)</li>
  //         <li>Tubectomy & tubal recanalization</li>
  //         <li>Dilation & Curettage (D&C), S&E</li>
  //         <li>Vaginal and abdominal hysterectomy</li>
  //         <li>Laparoscopic cystectomy & myomectomy</li>
  //         <li>Diagnostic laparoscopy & laparotomy</li>
  //         <li>Endometrial biopsy & colposcopy procedures</li>
  //       </ul>
  //     </section>

  //     <!-- Professional Experience -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Professional Experience
  //       </h2>

  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
  //         <li>Senior_toggle Consultant & Registrar – Apollo Cradle, Bengaluru</li>
  //         <li>Senior Resident – Kasturba Medical College, Mangaluru</li>
  //         <li>Junior Resident (3 Years) – A.J. Institute of Medical Sciences, Mangalore</li>
  //         <li>Attending Consultant – Paras Hospital, Gurgaon</li>
  //         <li>Current Role: Consultant OBGYN at Manipal Hospital, Varthur</li>
  //       </ul>

  //       <p class="text-sm text-gray-700 mt-2">
  //         She has also completed 6 months of advanced laparoscopic training, enhancing her expertise in minimally invasive gynecological surgeries.
  //       </p>
  //     </section>

  //     <!-- Research & Publications -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Research & Publications
  //       </h2>

  //       <p class="text-sm text-gray-700">
  //         Dr. Shreesha Marla actively contributes to academic research and clinical studies in obstetrics and gynecology.
  //       </p>

  //       <p class="text-sm text-gray-700 font-medium mt-2">Published Research:</p>
  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1 mt-1">
  //         <li>An Undiagnosed Case of Placenta Increta – IJRCog, 2023</li>
  //         <li>Correlation of Estimated Fetal Weight by Ultrasound and Birth Weight – IJRCog, 2023</li>
  //       </ul>

  //       <p class="text-sm text-gray-700 font-medium mt-3">Dissertation:</p>
  //       <p class="text-sm text-gray-700">
  //         Correlation between first trimester CRL and birth weight in a tertiary care center.
  //       </p>
  //     </section>

  //     <!-- Awards & Achievements -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Awards & Achievements
  //       </h2>

  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
  //         <li>Best Paper Award – Manipal Obstetrics & Gynaecology Resident Conference</li>
  //         <li>ICMR-approved dissertation research</li>
  //         <li>Active participant in national & international OBGYN conferences (FOGSI, RCOG, KSOGA)</li>
  //       </ul>
  //     </section>

  //     <!-- Languages Spoken -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Languages Spoken
  //       </h2>

  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
  //         <li>English</li>
  //         <li>Hindi</li>
  //         <li>Kannada</li>
  //         <li>Tulu</li>
  //       </ul>
  //     </section>

  //     <!-- Why Choose -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Why Choose Dr. Shreesha Marla at ELV Healthcare?
  //       </h2>

  //       <ul class="list-disc list-inside text-sm text-gray-700 space-y-1">
  //         <li>Patient-first and ethical medical approach</li>
  //         <li>Strong focus on safe motherhood & women’s wellness</li>
  //         <li>Expertise in both normal and high-risk pregnancies</li>
  //         <li>Skilled in advanced laparoscopic gynecology</li>
  //         <li>Evidence-based treatment aligned with global standards</li>
  //       </ul>
  //     </section>

  //     <!-- Appointment CTA -->
  //     <section>
  //       <h2 class="text-xl font-semibold text-gray-800 mb-2 mt-2">
  //         Book an Appointment with Dr. Shreesha Marla
  //       </h2>

  //       <p class="text-sm text-gray-700">
  //         For expert pregnancy care, gynecology consultations, and women’s health services, visit ELV Healthcare and consult Dr. Shreesha Marla for compassionate and comprehensive care.
  //       </p>
  //     </section>
  // `,
  // },

  //   {
  //     name: "Dr. Abdul Aziz Riyaz",
  //     dis: (
  //       <h6 className="pt-2 font-medium">
  //         MBBS, MS - General Surgery, MCh - Neuro Surgery
  //       </h6>
  //     ),
  //     img: "/doctor-images/Dr. Abdul Aziz Riyaz.webp",
  //     rate: "",
  //     exper: "13",
  //     timings: "FRI - 10 AM to 11 AM",
  //     link: "/bestneurosurgeoninwhitefield-by-dr-abdul-aziz-riyaz",
  //     depat: "Neurosurgeon",
  //     con: `
  //       <div class="doctor-profile">
  //   <p>
  //     Dr Abdul has a distinguished academic career, which enabled him to acquire all the necessary surgical skills to deal with the challenging problems in Neurosurgery.
  //   </p>
  //   <p>
  //     Dr. Abdul Aziz Riyaz is a proficient Neurosurgeon with an experience of 7 years. He is an experienced, skilled and awarded doctor in his field of specialization. He is presently Consultant – Brain and Spine services, at Columbia Asia Hospital - Sarjapur Road, Bangalore.
  //   </p>
  //   <p>
  //     Expertise in the field of spine and brain related problems like back pain, numbness in hands, spine injury, headaches, epilepsy etc.
  //   </p>
  //   <p>
  //     He is competent to handle both emergency and elective neurosurgery related surgeries. Spectrum of cases include Brain and Spine traumatic injuries, Brain tumours, Spinal tumours and Spinal degenerative and infective diseases, spinal fixations, laminectomies, discectomies, craniotomies, burrholes and decompression.
  //   </p>
  //   <p>
  //     Minimally invasive surgeries for most procedures has been his area of special focus. He performs advanced minimally invasive surgeries in Brain and Spine.
  //   </p>
  //   <p>
  //     He is a professional who values ethics and practices evidence based medicine and follows international and national protocols in patient management.
  //   </p>

  //   <h2><strong>Services</strong></h2>
  //   <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //     <li style="margin-bottom: 6px;">Spine Surgery</li>
  //     <li style="margin-bottom: 6px;">Spinal Disorders</li>
  //     <li style="margin-bottom: 6px;">Spinal Disc Surgery</li>
  //     <li style="margin-bottom: 6px;">Spinal Surgery</li>
  //     <li style="margin-bottom: 6px;">Peripheral Neuro surgery</li>
  //     <li style="margin-bottom: 6px;">Nerve and Muscle Disorders</li>
  //     <li style="margin-bottom: 6px;">Herniated Disc</li>
  //     <li style="margin-bottom: 6px;">Brain Tumor Surgery</li>
  //     <li style="margin-bottom: 6px;">Deep Brain Stimulation</li>
  //     <li style="margin-bottom: 6px;">Epilepsy surgery</li>
  //     <li style="margin-bottom: 6px;">Epilepsy Treatment</li>
  //     <li style="margin-bottom: 6px;">Spinal Deformity Correction</li>
  //     <li style="margin-bottom: 6px;">Decompression Micovascular</li>
  //     <li style="margin-bottom: 6px;">Brain Aneurysm Treatment</li>
  //     <li style="margin-bottom: 6px;">Brain Aneurysm Coiling</li>
  //     <li style="margin-bottom: 6px;">Brain Dural Arteriovenous Fistula Embolization</li>
  //     <li style="margin-bottom: 6px;">Brain Arteriovenous Fistula Embolization</li>
  //     <li style="margin-bottom: 6px;">Paralysis</li>
  //     <li style="margin-bottom: 6px;">Spinal Fusion</li>
  //     <li style="margin-bottom: 6px;">Spine Injury</li>
  //     <li style="margin-bottom: 6px;">Spinal Cord Injury Treatment</li>
  //     <li style="margin-bottom: 6px;">Scoliosis Correction</li>
  //     <li style="margin-bottom: 6px;">Cerebrovascular Surgery</li>
  //     <li style="margin-bottom: 6px;">Laminectomy</li>
  //     <li style="margin-bottom: 6px;">Foot Drop</li>
  //     <li style="margin-bottom: 6px;">Spinal Tap</li>
  //     <li style="margin-bottom: 6px;">Brain Aneursym Surgery</li>
  //     <li style="margin-bottom: 6px;">Cerebrospinal Fluid Shunt</li>
  //     <li style="margin-bottom: 6px;">Ventriculoperitoneal Shunt</li>
  //     <li style="margin-bottom: 6px;">Migraine Treatment</li>
  //     <li style="margin-bottom: 6px;">Minimally-Invasive TLIF (Transforaminal Lumbar Interbody Fusion)</li>
  //     <li style="margin-bottom: 6px;">Lumbar Radiofrequency Neurotomy</li>
  //   </ul>

  //   <h2><strong>Specializations</strong></h2>
  //   <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //     <li style="margin-bottom: 6px;">Neurosurgeon</li>
  //     <li style="margin-bottom: 6px;">Neurologist</li>
  //     <li style="margin-bottom: 6px;">Spine Surgeon (Neuro)</li>
  //   </ul>

  //   <h2><strong>Education</strong></h2>
  //   <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //     <li style="margin-bottom: 6px;">MBBS - YENEPOYA UNIVERSITY, 2012</li>
  //     <li style="margin-bottom: 6px;">MS - General Surgery - Rajiv Gandhi University of Health Sciences, 2015</li>
  //     <li style="margin-bottom: 6px;">MCh - Neuro Surgery - Dr. NTR University of Health Sciences Andhra Pradesh, 2018</li>
  //   </ul>

  //   <h2><strong>Memberships</strong></h2>
  //   <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //     <li style="margin-bottom: 6px;">Neurological Society of India</li>
  //   </ul>

  //   <h2><strong>Experience</strong></h2>
  //   <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 1em; color: #444;">
  //     <li style="margin-bottom: 6px;">2018 - 2020 consultant neurosurgeon at Columbia Asia Hospital, Sarjapur road, Bangalore</li>
  //   </ul>
  // </div>

  //     `,
  //   },
];
